// src/components/destination-best-time-to-go-information/destination-best-time-to-go-information.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    description\n    id\n    size\n    title\n    theme\n    withBackground\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    accessibility\n    disabled\n    icon {\n      ...IconFragment\n    }\n    analytics {\n      eventType\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    action {\n      ... on UILinkAction {\n        resource {\n          ... on HttpURI {\n            value\n          }\n        }\n        target\n        useRelativePath\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment IllustrationFragments on Illustration {\n    description\n    id\n    link: url\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment MarkFragments on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragment\n    }\n\n    ... on Mark {\n      ...MarkFragments\n    }\n\n    ... on Illustration {\n      ...IllustrationFragments\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationBestTimeToGoInformationExpandoFragment on DestinationBestTimeToGoInformationExpando {\n    graphic {\n      ...UIGraphicFragment\n    }\n    content {\n      collapseAnalytics {\n        linkName\n        referrerId\n      }\n      expandAnalytics {\n        linkName\n        referrerId\n      }\n      collapsedLabel\n      expanded\n      expandedLabel\n      subtitle\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      resource {\n        value\n      }\n      analytics {\n        referrerId\n        linkName\n      }\n      target\n    }\n    text\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardMessagingCardFragment on EGDSStandardMessagingCard {\n    background\n    buttons {\n      ...EGDSButtonFragment\n    }\n    heading\n    message\n    links {\n      ...EGDSStandardLinkFragment\n    }\n    rightIcon {\n      ...IconFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationTemperatureFragment on DestinationTemperature {\n    accessibility\n    interaction {\n      eventType\n      linkName\n      referrerId\n    }\n    max\n    maxTempText\n    min\n    minTempText\n    weatherIcon {\n      ...IconFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationMonthlyBadgeFragment on EGDSStandardBadge {\n    accessibility\n    text\n    theme\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment MonthsForecastTabFragment on MonthsForecastTab {\n    accessibility\n    badges {\n      ...DestinationMonthlyBadgeFragment\n    }\n    click {\n      eventType\n      linkName\n      referrerId\n    }\n    description\n    label\n    monthName\n    temperature {\n      ...DestinationTemperatureFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment MonthsForecastsTabsFragment on MonthsForecastsTabs {\n    accessibility\n    monthsTabs {\n      ...MonthsForecastTabFragment\n    }\n    overallMaxTemperature\n    overallMinTemperature\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationMonthlyHistoricalForecastFragment on DestinationMonthlyHistoricalForecast {\n    actions {\n      ...EGDSStandardMessagingCardFragment\n    }\n    description\n    monthsForecast {\n      ...MonthsForecastsTabsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsDestinationPricingFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationInsightsPriceFragment on DestinationInsightsPrice {\n    priceAsNumber\n    priceAsText\n    currency\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationInsightsMonthlyDataFragment on DestinationInsightsMonthlyData {\n    selected\n    monthName\n    label\n    averagePrice {\n      ...DestinationInsightsPriceFragment\n    }\n    click {\n      ...ClientSideAnalyticsDestinationPricingFragment\n    }\n    accessibility\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSheetFragment on EGDSSheet {\n    closeAnalytics {\n      ...ClientSideAnalyticsDestinationPricingFragment\n    }\n    closeText\n    sheetType\n  }\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    theme\n    weight\n    accessibility\n    decorative\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSPlainTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSStylizedTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationInsightsTooltipFragment on DestinationInsightsTooltip {\n    tooltipSheet {\n      ...EGDSSheetFragment\n    }\n    content {\n      ...EGDSSpannableTextFragment\n    }\n    closeIcon {\n      ...IconFragment\n    }\n    button {\n      ...EGDSButtonFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationInsightsMonthlyDetailsFragment on DestinationInsightsMonthlyDetails {\n    title\n    subtitle\n    tooltip {\n      ...DestinationInsightsTooltipFragment\n    }\n    monthlyData {\n      ...DestinationInsightsMonthlyDataFragment\n    }\n    accessibility\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment MonthsForecastsTabsPriceFragment on DestinationInsightsMonthlyDetails {\n    monthlyData {\n      ...DestinationInsightsMonthlyDataFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationInsightsMonthlyDetailsTabsFragment on DestinationInsightsMonthlyDetails {\n    title\n    subtitle\n    tooltip {\n      ...DestinationInsightsTooltipFragment\n    }\n    ...MonthsForecastsTabsPriceFragment\n    accessibility\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationBestTimeToGoInformationTabInformationFragment on DestinationInformation {\n    ... on DestinationInsightsMonthlyDetails {\n      ...DestinationInsightsMonthlyDetailsFragment\n    }\n    ... on DestinationMonthlyHistoricalForecast {\n      ...DestinationMonthlyHistoricalForecastFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationBestTimeToGoInformationTabsFragment on DestinationBestTimeToGoInformation {\n    tabs {\n      title {\n        text\n      }\n      impression {\n        linkName\n        referrerId\n      }\n      information {\n        ...DestinationBestTimeToGoInformationTabInformationFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  query DestinationBestTimeToGoInformationQuery($placeId: String!, $context: ContextInput!) {\n    destinationBestTimeToGoInformation(placeId: $placeId, context: $context) {\n      impression {\n        referrerId\n        linkName\n      }\n      viewAllPropertiesButton {\n        ...EGDSButtonFragment\n      }\n      expando {\n        ...DestinationBestTimeToGoInformationExpandoFragment\n      }\n      ...DestinationBestTimeToGoInformationTabsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardAttributionFragment on EGDSSpannableText {\n    __typename\n    contents {\n      __typename\n      text\n      ... on EGDSStandardLink {\n        ...EGDSStandardLinkFragment\n      }\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment ImageFragment on Image {\n    aspectRatio\n    description\n    url\n  }\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationImageGalleryItemFragment on DestinationImageGalleryItem {\n    impression {\n      ...ClientSideAnalyticsDestinationPricingFragment\n    }\n    attribution {\n      ...DestinationRecommendationCardAttributionFragment\n    }\n    image {\n      ...ImageFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n  }\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSParagraphFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardImageFragment on DestinationRecommendationCardImage {\n    attribution {\n      ...DestinationRecommendationCardAttributionFragment\n    }\n    image {\n      ...ImageFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardMediaFragment on DestinationRecommendationCardMedia {\n    ... on DestinationRecommendationCardImage {\n      image {\n        ...ImageFragment\n      }\n      attribution {\n        ...DestinationRecommendationCardAttributionFragment\n      }\n    }\n    ... on DestinationRecommendationCardImages {\n      images {\n        ...DestinationRecommendationCardImageFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    accessibility\n    text\n    theme\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardFragment on DestinationRecommendationCard {\n    heading {\n      title\n    }\n    affinities {\n      accessibility\n      badges {\n        ...EGDSStandardBadgeFragment\n      }\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    action {\n      analytics {\n        referrerId\n      }\n      resource {\n        value\n      }\n    }\n    media {\n      ...DestinationRecommendationCardMediaFragment\n    }\n    details {\n      heading {\n        title\n      }\n      content {\n        ...EGDSParagraphFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCarouselDestinationGuideFragment on EGDSCarousel {\n    nextButton {\n      ...EGDSButtonFragment\n    }\n    previousButton {\n      ...EGDSButtonFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationGalleryFragment on DestinationGallery {\n    carousel {\n      ...EGDSCarouselDestinationGuideFragment\n    }\n    items {\n      ...DestinationImageGalleryItemFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSExpandoPeekFragment on EGDSExpandoPeek {\n    expandedLabel\n    collapsedLabel\n    lines\n    items\n    collapseAnalytics {\n      eventType\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    collapsedAccessibilityText\n    expandAnalytics {\n      eventType\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    expanded\n    expandedAccessibilityText\n  }\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  query DestinationGuideHeadingQuery($placeId: String!, $imageLimit: Int!, $context: ContextInput!) {\n    destinationHeading(headingCriteria: { imageLimit: $imageLimit, placeId: $placeId }, context: $context) {\n      __typename\n      title\n      description\n      subtitle\n      gallery {\n        ...DestinationGalleryFragment\n      }\n      destinationBadges {\n        accessibility\n        badges {\n          ...EGDSStandardBadgeFragment\n        }\n      }\n      expandoPeek {\n        ...EGDSExpandoPeekFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment MediaImageAttributionFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ... on EGDSStandardLink {\n        ...EGDSStandardLinkFragment\n      }\n      ... on EGDSPlainText {\n        text\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationHeroImageFragment on Image {\n    aspectRatio\n    description\n    url\n  }\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  query DestinationHeroMediaQuery($destinationHeroMediaCriteria: DestinationHeroMediaCriteriaInput!, $context: ContextInput!) {\n    destinationHeroMedia(destinationHeroMediaCriteria: $destinationHeroMediaCriteria, context: $context) {\n      title {\n        text\n      }\n      subTitle {\n        text\n      }\n      media {\n        attribution {\n          ...MediaImageAttributionFragment\n        }\n        media {\n          ...DestinationHeroImageFragment\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  query DestinationGuideNeighborhoodQuery(\n    $placeId: String!\n    $strategy: DestinationRecommendationStrategy!\n    $type: DestinationRecommendationPlaceType!\n    $context: ContextInput!\n  ) {\n    destinationRecommendation(recommendationCriteria: { referencePlaceId: $placeId, strategy: $strategy, type: $type }, context: $context) {\n      __typename\n      heading {\n        title\n      }\n      cards {\n        ...DestinationRecommendationCardFragment\n      }\n      carousel {\n        ...EGDSCarouselDestinationGuideFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationTipItemFragment on DestinationTipItem {\n    destinationTips {\n      ... on DestinationTip {\n        description {\n          ...EGDSSpannableTextFragment\n        }\n        icon {\n          ...IconFragment\n        }\n      }\n    }\n    name\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  query DestinationGuideExpertTipsQuery($placeId: String!, $context: ContextInput!) {\n    destinationExpertTips(placeId: $placeId, context: $context) {\n      title\n      tips {\n        ... on DestinationTips {\n          category\n          items {\n            ...DestinationTipItemFragment\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  query DestinationGuideHeadingTipQuery($placeId: String!, $context: ContextInput!) {\n    destinationHeadingTip(placeId: $placeId, context: $context) {\n      lightImage {\n        ...ImageFragment\n      }\n      text {\n        ...EGDSSpannableTextFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationHeadingFragment on DestinationRecommendationHeading {\n    title\n    subTitle\n    superTitle\n  }\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationGroupFragment on DestinationRecommendationGroup {\n    cards {\n      ...DestinationRecommendationCardFragment\n    }\n    carousel {\n      ...EGDSCarouselDestinationGuideFragment\n    }\n    heading {\n      ...DestinationRecommendationHeadingFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  query DestinationGuideThingsToDoQuery($placeId: String!, $context: ContextInput!) {\n    thingsToDo(placeId: $placeId, context: $context) {\n      heading {\n        ...DestinationRecommendationHeadingFragment\n      }\n      groups {\n        ...DestinationRecommendationGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  query DestinationGuideBestTimeToGoQuery($placeId: String!, $context: ContextInput!) {\n    bestTimeToGo(placeId: $placeId, context: $context) {\n      impression {\n        eventType\n        linkName\n        referrerId\n      }\n      monthlyHistoricalForecast {\n        ...DestinationMonthlyHistoricalForecastFragment\n      }\n      subtitle {\n        ...EGDSSpannableTextFragment\n      }\n      title\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationInsightsPriceRangeFragment on DestinationInsightsPriceRange {\n    lowerBound {\n      ...DestinationInsightsPriceFragment\n    }\n    higherBound {\n      ...DestinationInsightsPriceFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  fragment PriceInsightsExpandoCardFragment on EGDSExpandoPeek {\n    collapseAnalytics {\n      linkName\n      referrerId\n      eventType\n    }\n    collapsedLabel\n    expandAnalytics {\n      linkName\n      referrerId\n      eventType\n    }\n    expandedLabel\n    expanded\n    expandedAccessibilityText\n    collapsedAccessibilityText\n  }\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  query DestinationPriceInsightsQuery($placeId: String!, $context: ContextInput!) {\n    destinationPriceInsights(placeId: $placeId, context: $context) {\n      title {\n        ...EGDSSpannableTextFragment\n      }\n      subtitle {\n        ...EGDSSpannableTextFragment\n      }\n      superTitle {\n        ...EGDSSpannableTextFragment\n      }\n      impression {\n        ...ClientSideAnalyticsDestinationPricingFragment\n      }\n      expandoIcon {\n        ...IconFragment\n      }\n      typicalRange {\n        ...DestinationInsightsPriceRangeFragment\n      }\n      currentMonthAverage {\n        ...DestinationInsightsPriceFragment\n      }\n      expando {\n        ...PriceInsightsExpandoCardFragment\n      }\n      monthlyDetails {\n        ...DestinationInsightsMonthlyDetailsFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextIconListItemFragment on EGDSTextIconListItem {\n    text\n    icon {\n      id\n    }\n  }\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextIconListFragment on EGDSTextIconList {\n    listItems {\n      ...EGDSTextIconListItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  fragment SimilarDestinationTabsFragment on DestinationRecommendationGroup {\n    carousel {\n      ...EGDSCarouselDestinationGuideFragment\n    }\n    cards {\n      heading {\n        title\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n      media {\n        ...DestinationRecommendationCardMediaFragment\n      }\n      details {\n        heading {\n          title\n          subTitle\n        }\n        content {\n          ...EGDSParagraphFragment\n          ...EGDSTextIconListFragment\n        }\n        button {\n          ...EGDSButtonFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  query SimilarDestinations($similarDestinationsCriteria: SimilarDestinationsCriteriaInput!, $context: ContextInput!) {\n    similarDestinations(similarDestinationsCriteria: $similarDestinationsCriteria, context: $context) {\n      heading {\n        title\n      }\n      ...SimilarDestinationTabsFragment\n      impression {\n        linkName\n        referrerId\n      }\n      interaction {\n        referrerId\n        linkName\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
import React27 from "react";
import { gql as gql29, useQuery } from "@apollo/client";
import { ViewRow } from "@egds/react-search-experience";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex8 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
// src/components/egds-button/egds-button.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkOverlayButton, UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
// src/components/icon/icon.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var __Fragment = gql(_templateObject());
var Icon = function(param) /* @__PURE__ */ {
    var className = param.className, data = param.data;
    var _data_title, _data_theme;
    return React.createElement(UitkIcon, {
        className: className,
        description: data.description,
        id: data.id + Math.random().toString(36).slice(2, 5),
        name: data.id,
        size: data.size ? UitkIconSize[data.size] : void 0,
        title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: (_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
        spotlight: data.withBackground ? "info" : void 0
    });
};
Icon.displayName = "Icon";
Icon.fragment = __Fragment;
// src/__generated__/types.ts
var DestinationRecommendationPlaceType = /* @__PURE__ */ function(DestinationRecommendationPlaceType2) {
    DestinationRecommendationPlaceType2["CITY"] = "CITY";
    DestinationRecommendationPlaceType2["NEIGHBORHOOD"] = "NEIGHBORHOOD";
    DestinationRecommendationPlaceType2["POI"] = "POI";
    return DestinationRecommendationPlaceType2;
}(DestinationRecommendationPlaceType || {});
var DestinationRecommendationStrategy = /* @__PURE__ */ function(DestinationRecommendationStrategy2) {
    DestinationRecommendationStrategy2["NEARBY"] = "NEARBY";
    DestinationRecommendationStrategy2["SIMILAR"] = "SIMILAR";
    DestinationRecommendationStrategy2["TOP"] = "TOP";
    return DestinationRecommendationStrategy2;
}(DestinationRecommendationStrategy || {});
var _obj;
// src/utils/link-target-mapper.ts
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */ , "_self"), _obj);
// src/components/egds-button/ui-link-action.ts
var getUILinkActionPath = function(action, overrideUseRelativePath) {
    if (action.resource.__typename !== "HttpURI") {
        return null;
    }
    return action.useRelativePath || overrideUseRelativePath ? action.resource.relativePath : action.resource.value;
};
var getUILinkActionTarget = function(action) {
    return UILinkTargetMap[action.target];
};
var deriveLinkProps = function(action, overrideUseRelativePath) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getUILinkActionPath(action, overrideUseRelativePath);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getUILinkActionTarget(action),
        tag: "a"
    };
};
// src/components/egds-button/egds-button.tsx
var _Fragment = gql2(_templateObject1(), Icon.fragment);
var EGDSButton = function(param) {
    var className = param.className, domRef = param.domRef, href = param.href, isFullWidth = param.isFullWidth, onClickHandler = param.onClickHandler, size = param.size, data = param.data;
    var __typename = data.__typename, accessibility = data.accessibility, primary = data.primary, disabled = data.disabled, icon = data.icon, analytics = data.analytics, action = data.action;
    var clickTracker = useClickTracker();
    var linkProps = deriveLinkProps(action);
    var analyticsButton = analytics ? {
        description: analytics.linkName,
        id: analytics.referrerId,
        callback: function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }
    } : void 0;
    var handleOnClick = React2.useCallback(function() {
        onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler();
    }, [
        onClickHandler
    ]);
    if (!primary) {
        return null;
    }
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : primary,
        role: "button",
        className: className,
        disabled: disabled,
        href: href,
        isFullWidth: isFullWidth,
        onClick: handleOnClick,
        size: size,
        domRef: domRef,
        analytics: analyticsButton
    }, linkProps);
    switch(__typename){
        case "UIPrimaryButton":
            return /* @__PURE__ */ React2.createElement(UitkPrimaryButton, _object_spread({}, buttonProps), primary);
        case "UISecondaryButton":
            var _icon_id;
            return /* @__PURE__ */ React2.createElement(UitkSecondaryButton, _object_spread({}, buttonProps), primary, icon && /* @__PURE__ */ React2.createElement(UitkIcon2, {
                name: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : ""
            }));
        case "UITertiaryButton":
            return /* @__PURE__ */ React2.createElement(UitkTertiaryButton, _object_spread({}, buttonProps), primary);
        case "EGDSOverlayButton":
            var _icon_id1;
            return /* @__PURE__ */ React2.createElement(UitkOverlayButton, _object_spread({}, buttonProps), icon && /* @__PURE__ */ React2.createElement(UitkIcon2, {
                name: (_icon_id1 = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id1 !== void 0 ? _icon_id1 : ""
            }), primary);
        default:
            return null;
    }
};
EGDSButton.fragment = _Fragment;
EGDSButton.displayName = "EGDSButton";
// src/components/destination-best-time-to-go-information/private/destination-best-time-to-go-information-expando.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard } from "uitk-react-cards";
import { UitkExpandoList, UitkExpandoListItem } from "uitk-react-expando";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
// src/components/ui-graphic/ui-graphic.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkSpacing } from "uitk-react-spacing";
// src/components/ui-graphic/illustration.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var IllustrationFragment = gql3(_templateObject2());
var Illustration = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React3.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link
    });
};
Illustration.displayName = "Illustration";
Illustration.fragment = IllustrationFragment;
// src/components/ui-graphic/mark.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var MarkFragment = gql4(_templateObject3());
var Mark = function(param) {
    var className = param.className, data = param.data;
    var _data_url;
    return /* @__PURE__ */ React4.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.markSize ? UitkMarkSize[data.markSize] : void 0,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
Mark.displayName = "Mark";
Mark.fragment = MarkFragment;
// src/components/ui-graphic/ui-graphic.tsx
var __UIGraphicFragment = gql5(_templateObject4(), Icon.fragment, Mark.fragment, Illustration.fragment);
var UiGraphic = function(param) {
    var className = param.className, data = param.data, padding = param.padding;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React5.createElement(UitkSpacing, {
                padding: padding
            }, /* @__PURE__ */ React5.createElement(Icon, {
                className: className,
                data: data
            }));
        case "Mark":
            return /* @__PURE__ */ React5.createElement(Mark, {
                className: className,
                data: data
            });
        case "Illustration":
            return /* @__PURE__ */ React5.createElement(Illustration, {
                data: data
            });
        default:
            return null;
    }
};
UiGraphic.displayName = "UiGraphic";
UiGraphic.fragment = __UIGraphicFragment;
// src/components/destination-best-time-to-go-information/private/destination-best-time-to-go-information-expando.tsx
var __fragment = gql6(_templateObject5(), UiGraphic.fragment);
var DestinationBestTimeToGoInformationExpando = function(param) {
    var children = param.children, data = param.data, backgroundThemeOverride = param.backgroundThemeOverride;
    var graphic = data.graphic, content = data.content;
    var collapseAnalytics = content.collapseAnalytics, expandAnalytics = content.expandAnalytics, collapsedLabel = content.collapsedLabel, expanded = content.expanded, expandedLabel = content.expandedLabel, subtitle = content.subtitle;
    var _React6_useState = _sliced_to_array(React6.useState(expanded), 2), isVisible = _React6_useState[0], setIsVisible = _React6_useState[1];
    var track = useClickTracker2();
    var onToggle = React6.useCallback(function() {
        if (collapseAnalytics && expandAnalytics) {
            var referrerId = isVisible ? collapseAnalytics.referrerId : expandAnalytics.referrerId;
            var linkName = isVisible ? collapseAnalytics.linkName : expandAnalytics.linkName;
            track(referrerId, linkName);
        }
        setIsVisible(!isVisible);
    }, [
        isVisible,
        track
    ]);
    var expandoTitle = /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement(UitkLayoutFlex, {
        direction: "row",
        alignItems: "center",
        space: "three"
    }, graphic && /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React6.createElement(UiGraphic, {
        data: graphic
    })), /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem, {
        grow: 1
    }, /* @__PURE__ */ React6.createElement(UitkLayoutFlex, {
        direction: "column",
        alignItems: "start",
        space: "half"
    }, /* @__PURE__ */ React6.createElement(UitkHeading, {
        tag: "h2",
        size: 8,
        className: "is-visually-hidden"
    }, isVisible ? expandedLabel : collapsedLabel), /* @__PURE__ */ React6.createElement(UitkText, {
        size: 400,
        weight: "medium",
        "aria-hidden": true
    }, isVisible ? expandedLabel : collapsedLabel), /* @__PURE__ */ React6.createElement(UitkText, {
        size: 200
    }, subtitle)))));
    var description = /* @__PURE__ */ React6.createElement(UitkSpacing2, {
        style: {
            marginInline: "-1rem"
        }
    }, /* @__PURE__ */ React6.createElement("div", null, children));
    return /* @__PURE__ */ React6.createElement(UitkCard, {
        backgroundTheme: backgroundThemeOverride !== null && backgroundThemeOverride !== void 0 ? backgroundThemeOverride : "highlight"
    }, /* @__PURE__ */ React6.createElement(UitkSpacing2, {
        padding: "three"
    }, /* @__PURE__ */ React6.createElement(UitkExpandoList, null, /* @__PURE__ */ React6.createElement(UitkExpandoListItem, {
        isVisible: isVisible,
        triggerPosition: "trailing",
        expandoTitle: expandoTitle,
        expandoDescription: description,
        onToggle: onToggle,
        isIndented: false
    }))));
};
DestinationBestTimeToGoInformationExpando.fragment = __fragment;
DestinationBestTimeToGoInformationExpando.displayName = "DestinationBestTimeToGoInformationExpando";
// src/components/destination-best-time-to-go-information/private/destination-best-time-to-go-information-skeleton.tsx
import React7 from "react";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
var DestinationBestTimeToGoInformationPlaceholder = function() {
    return /* @__PURE__ */ React7.createElement(UitkSpacing3, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(UitkLayoutFlex2, {
        direction: "column",
        blockSize: "full_size",
        space: "four"
    }, /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React7.createElement(UitkLineSkeleton, null)), /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React7.createElement(UitkLineSkeleton, {
        type: "secondary"
    })))));
};
DestinationBestTimeToGoInformationPlaceholder.displayName = "DestinationBestTimeToGoInformationPlaceholder";
// src/components/destination-best-time-to-go-information/private/destination-best-time-to-go-information-tabs.tsx
import React26 from "react";
import { gql as gql28 } from "@apollo/client";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard4 } from "uitk-react-cards";
import { UitkTab as UitkTab2, UitkTabs as UitkTabs2, UitkTabsBackGroundColorType, UitkTabsType as UitkTabsType2 } from "uitk-react-tabs";
// src/components/destination-best-time-to-go-information/private/destination-best-time-to-go-information-tab-information.tsx
import React25 from "react";
import { gql as gql27 } from "@apollo/client";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
// src/components/destination-guide-best-time-to-go/__private/destination-monthly-historical-forecast/destination-monthly-historical-forecast.tsx
import React14 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkLayoutGrid as UitkLayoutGrid4, UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
// src/components/egds-standard-messaging-card/egds-standard-messaging-card.tsx
import React9 from "react";
import { gql as gql8 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-standard-link/egds-standard-link.tsx
import React8 from "react";
import { gql as gql7 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLink, UitkLinkSizes } from "uitk-react-link";
import { UitkText as UitkText2 } from "uitk-react-text";
var _obj1;
// ../internal/src/components/utils/link-target-mapper.ts
var UILinkTargetMap2 = (_obj1 = {}, _define_property(_obj1, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj1, "INTERNAL" /* INTERNAL */ , "_self"), _obj1);
// ../internal/src/components/egds-standard-link/egds-standard-link.tsx
var fragment = gql7(_templateObject6());
var EGDSStandardLink = function(param) {
    var data = param.data, textProps = param.textProps, _param_showIcon = param.showIcon, showIcon = _param_showIcon === void 0 ? false : _param_showIcon, _param_linkSize = param.linkSize, linkSize = _param_linkSize === void 0 ? UitkLinkSizes.get("medium") : _param_linkSize, _param_theme = param.theme, theme = _param_theme === void 0 ? "default" : _param_theme, _param_enableTracking = param.enableTracking, enableTracking = _param_enableTracking === void 0 ? false : _param_enableTracking;
    var action = data.action, text = data.text;
    var target = action.target;
    var clickTracker = useClickTracker3();
    var analytics = action.analytics;
    var trackEvent = React8.useCallback(function() {
        if (enableTracking) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        analytics,
        clickTracker,
        enableTracking
    ]);
    var resource = action.resource, accessibility = action.accessibility;
    return /* @__PURE__ */ React8.createElement(UitkLink, {
        onClickCapture: trackEvent,
        size: linkSize,
        theme: theme
    }, /* @__PURE__ */ React8.createElement("a", {
        target: UILinkTargetMap2[target],
        rel: "noopener",
        href: resource.value,
        "aria-label": accessibility || ""
    }, textProps ? /* @__PURE__ */ React8.createElement(UitkText2, _object_spread({}, textProps), text) : text, !showIcon && /* @__PURE__ */ React8.createElement(UitkIcon3, {
        "data-stid": "lodging-link-message-icon",
        name: "arrow_forward",
        size: UitkIconSize2.EXTRA_SMALL
    }), accessibility && /* @__PURE__ */ React8.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment;
EGDSStandardLink.displayName = "EGDSStandardLink";
// src/components/egds-standard-messaging-card/egds-standard-messaging-card.tsx
import { UitkCard as UitkCard2, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
var fragment2 = gql8(_templateObject7(), Icon.fragment, EGDSButton.fragment, UiGraphic.fragment, EGDSStandardLink.fragment);
var EGDSStandardMessagingCard = function(param) {
    var data = param.data;
    var graphic = data.graphic, message = data.message, rightIcon = data.rightIcon, links = data.links;
    var clickTracker = useClickTracker4();
    var handleClick = React9.useCallback(function() {
        if (links) {
            clickTracker(links[0].action.analytics.referrerId, links[0].action.analytics.linkName);
        }
    }, [
        links,
        clickTracker
    ]);
    return /* @__PURE__ */ React9.createElement(UitkCard2, {
        padded: true,
        border: true
    }, links && /* @__PURE__ */ React9.createElement(UitkCardLink, null, /* @__PURE__ */ React9.createElement("a", {
        "data-stid": links[0].text,
        onClick: handleClick,
        href: links[0].action.resource.value
    }, links[0].action.accessibility || links[0].action.resource.value)), /* @__PURE__ */ React9.createElement(UitkLayoutGrid, {
        columns: [
            "min-content",
            "1fr",
            "min-content"
        ],
        space: "three",
        alignItems: "center"
    }, /* @__PURE__ */ React9.createElement(UitkLayoutGridItem, null, graphic && (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && /* @__PURE__ */ React9.createElement(Icon, {
        data: graphic
    })), /* @__PURE__ */ React9.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React9.createElement(UitkHeading2, {
        tag: "h2",
        size: 7
    }, message)), /* @__PURE__ */ React9.createElement(UitkLayoutGridItem, null, rightIcon && /* @__PURE__ */ React9.createElement(Icon, {
        data: rightIcon
    }))));
};
EGDSStandardMessagingCard.displayName = "EGDSStandardMessagingCard";
EGDSStandardMessagingCard.fragment = fragment2;
// src/components/destination-guide-best-time-to-go/months-forecasts-tabs/months-forecasts-tabs.tsx
import React13 from "react";
import { gql as gql12 } from "@apollo/client";
import { YAxisLine } from "@egds/react-acquisition-marketing-growth-landing";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { Repeat, UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkScrollable } from "uitk-react-scrollable";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkTab, UitkTabs, UitkTabsType } from "uitk-react-tabs";
import { UitkText as UitkText4 } from "uitk-react-text";
// src/components/destination-guide-best-time-to-go/utils/destination-best-time-to-go-utils.tsx
var lastCarouselItems = function(monthList) {
    var finalMonthList = monthList.slice(-2);
    var initialMonth = monthList.slice(0, 3);
    return finalMonthList.concat(initialMonth);
};
var lastCarouselItemsTab = function(monthList) {
    var finalMonthList = monthList.slice(-5);
    var initialMonth = monthList.slice(0, 2);
    return finalMonthList.concat(initialMonth);
};
var maxTemperature = function(monthsTabs) {
    var maxTemp = 0;
    monthsTabs.forEach(function(monthTab) {
        var _monthTab_temperature;
        if ((monthTab === null || monthTab === void 0 ? void 0 : (_monthTab_temperature = monthTab.temperature) === null || _monthTab_temperature === void 0 ? void 0 : _monthTab_temperature.max) > maxTemp) {
            maxTemp = monthTab.temperature.max;
        }
    });
    return maxTemp;
};
var minTemperature = function(monthsTabs) {
    var _monthsTabs__temperature, _monthsTabs_;
    var minTemp = (_monthsTabs_ = monthsTabs[0]) === null || _monthsTabs_ === void 0 ? void 0 : (_monthsTabs__temperature = _monthsTabs_.temperature) === null || _monthsTabs__temperature === void 0 ? void 0 : _monthsTabs__temperature.min;
    monthsTabs.forEach(function(monthTab) {
        var _monthTab_temperature;
        if ((monthTab === null || monthTab === void 0 ? void 0 : (_monthTab_temperature = monthTab.temperature) === null || _monthTab_temperature === void 0 ? void 0 : _monthTab_temperature.min) < minTemp) {
            minTemp = monthTab.temperature.min;
        }
    });
    return minTemp;
};
// src/components/destination-guide-best-time-to-go/__private/destination-temperature/destination-temperature.tsx
import React10 from "react";
import { gql as gql9 } from "@apollo/client";
import { SetGridItem } from "@egds/react-acquisition-marketing-growth-landing";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
var __Fragment2 = gql9(_templateObject8(), Icon.fragment);
var DestinationTemperature = function(param) {
    var selected = param.selected, onClick = param.onClick, data = param.data;
    var weatherIcon = data.weatherIcon, max = data.max, min = data.min, maxTempText = data.maxTempText, minTempText = data.minTempText, accessibility = data.accessibility;
    var buttonSize = max - min;
    var onCheckedChange = React10.useCallback(function() {
        onClick();
    }, []);
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(UitkSpacing4, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React10.createElement(UitkText3, {
        align: "center"
    }, maxTempText)), /* @__PURE__ */ React10.createElement(UitkLayoutGrid2, {
        blockSize: "full_size",
        rows: buttonSize - 1,
        onClick: onCheckedChange
    }, /* @__PURE__ */ React10.createElement(UitkLayoutGridItem2, {
        rowSpan: "all",
        rowEnd: buttonSize,
        alignSelf: "center",
        justifySelf: "center"
    }, /* @__PURE__ */ React10.createElement(UitkSpacing4, {
        margin: {
            blockstart: "one",
            blockend: "one"
        }
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlex3, {
        direction: "column",
        justifyContent: "center",
        alignContent: "center",
        blockSize: "full_size"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem3, {
        alignSelf: "center"
    }, /* @__PURE__ */ React10.createElement(SetGridItem, {
        selected: selected,
        accessibility: accessibility || void 0
    }, /* @__PURE__ */ React10.createElement(Icon, {
        data: weatherIcon
    }))))))), /* @__PURE__ */ React10.createElement(UitkSpacing4, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React10.createElement(UitkText3, {
        align: "center"
    }, minTempText)));
};
DestinationTemperature.displayName = "DestinationTemperature";
DestinationTemperature.fragment = __Fragment2;
// src/components/destination-guide-best-time-to-go/months-forecasts-tab/months-forecasts-tab.tsx
import React12 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
// src/components/destination-guide-best-time-to-go/__private/destination-monthly-badge/destination-monthly-badge.tsx
import React11 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkBadgeStandard, UitkBadgeStandardThemes } from "uitk-react-badge";
var fragment3 = gql10(_templateObject9(), UiGraphic.fragment);
var DestinationMonthlyBadge = function(param) {
    var className = param.className, size = param.size, data = param.data;
    var graphic = data.graphic, text = data.text, theme = data.theme, accessibility = data.accessibility;
    var themeProps = theme ? UitkBadgeStandardThemes[theme] : void 0;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React11.createElement(UitkBadgeStandard, _object_spread({
        className: className !== null && className !== void 0 ? className : "",
        size: size,
        theme: themeProps,
        text: text
    }, accessibility && {
        a11yText: accessibility
    }), graphic && /* @__PURE__ */ React11.createElement(UiGraphic, {
        data: graphic
    }));
};
DestinationMonthlyBadge.fragment = fragment3;
DestinationMonthlyBadge.displayName = "DestinationMonthlyBadge";
// src/components/destination-guide-best-time-to-go/months-forecasts-tab/months-forecasts-tab.tsx
var __Fragment3 = gql11(_templateObject10(), DestinationMonthlyBadge.fragment, DestinationTemperature.fragment);
var MonthsForecastTab = function(param) {
    var data = param.data;
    var monthName = data.monthName, badges = data.badges;
    var monthBadges = badges === null || badges === void 0 ? void 0 : badges.map(function(badge, index) {
        return /* @__PURE__ */ React12.createElement(UitkSpacing5, {
            key: index,
            margin: {
                inlineend: "two",
                inlinestart: "one"
            }
        }, /* @__PURE__ */ React12.createElement("div", null, badge.accessibility && /* @__PURE__ */ React12.createElement("span", {
            className: "is-visually-hidden"
        }, badge.accessibility), /* @__PURE__ */ React12.createElement(DestinationMonthlyBadge, {
            data: badge
        })));
    });
    return /* @__PURE__ */ React12.createElement(UitkLayoutFlex4, {
        direction: "row",
        alignContent: "center",
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React12.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React12.createElement(UitkHeading3, {
        tag: "h2"
    }, monthName)), /* @__PURE__ */ React12.createElement(UitkLayoutFlexItem4, null, monthBadges));
};
MonthsForecastTab.displayName = "MonthsForecastTab";
MonthsForecastTab.fragment = __Fragment3;
// src/components/destination-guide-best-time-to-go/months-forecasts-tabs/months-forecasts-tabs.tsx
var __Fragment4 = gql12(_templateObject11(), MonthsForecastTab.fragment);
var MonthsForecastsTabs = function(param) {
    var customHeight = param.customHeight, isScrollable = param.isScrollable, data = param.data;
    var _lastCarouselItemList_selectedTabIndex, _lastCarouselItemList_selectedTabIndex1, _lastCarouselItemsTabList_selectedTabIndex, _lastCarouselItemsTabList_selectedTabIndex1;
    var monthsTabs = _to_consumable_array(data.monthsTabs || []);
    var _React13_useState = _sliced_to_array(React13.useState(0), 2), selectedTabIndex = _React13_useState[0], setSelectedTabIndexState = _React13_useState[1];
    var carouselIndex = React13.useRef(0);
    var clickTracker = useClickTracker5();
    var sectionHeight = customHeight || 300;
    var lastCarouselItemList = lastCarouselItems(monthsTabs);
    var lastCarouselItemsTabList = lastCarouselItemsTab(monthsTabs);
    var totalRows = maxTemperature(monthsTabs) - minTemperature(monthsTabs);
    var additionalRows = totalRows > 30 ? 8 : 5;
    var handleTabChange = function(tabIndex, isTemperatureInteraction) {
        setSelectedTabIndexState(tabIndex);
        var interactionItem;
        switch(carouselIndex.current){
            case 0:
                interactionItem = isTemperatureInteraction ? monthsTabs[tabIndex].temperature.interaction : monthsTabs[tabIndex].click;
                clickTracker(interactionItem.referrerId, interactionItem.linkName);
                break;
            case 1:
                interactionItem = isTemperatureInteraction ? lastCarouselItemsTabList[tabIndex].temperature.interaction : lastCarouselItemsTabList[tabIndex].click;
                clickTracker(interactionItem.referrerId, interactionItem.linkName);
                break;
            default:
                return null;
        }
    };
    var handleTabChangeSmall = function(tabIndex, isTemperatureInteraction) {
        setSelectedTabIndexState(tabIndex);
        var interactionItems;
        switch(carouselIndex.current){
            case 0:
                interactionItems = isTemperatureInteraction ? monthsTabs[tabIndex].temperature.interaction : monthsTabs[tabIndex].click;
                clickTracker(interactionItems.referrerId, interactionItems.linkName);
                break;
            case 1:
                interactionItems = isTemperatureInteraction ? monthsTabs[tabIndex + 5].temperature.interaction : monthsTabs[tabIndex + 5].click;
                clickTracker(interactionItems.referrerId, interactionItems.linkName);
                break;
            case 2:
                interactionItems = isTemperatureInteraction ? lastCarouselItemList[tabIndex].temperature.interaction : lastCarouselItemList[tabIndex].click;
                clickTracker(interactionItems.referrerId, interactionItems.linkName);
                break;
            default:
                return null;
        }
    };
    var getTab = function(monthTab, tabIndex) {
        var padding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
            blockstart: "two"
        };
        return /* @__PURE__ */ React13.createElement(UitkTab, {
            name: monthTab.label,
            key: "monthTab".concat(tabIndex),
            targetURI: "monthTab".concat(tabIndex)
        }, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
            padding: padding
        }, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(MonthsForecastTab, {
            data: monthTab
        }))));
    };
    var getDestinationTemperature = function(monthList, monthTab, tabIndex, handleTabChangeFunc, rowDelta) {
        var tabIndexDelta = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
        return /* @__PURE__ */ React13.createElement(React13.Fragment, null, monthList.indexOf(monthTab) === selectedTabIndex + tabIndexDelta && getVerticalLine(tabIndex, setGridRow(monthTab.temperature.max) - 1), /* @__PURE__ */ React13.createElement(UitkLayoutGridItem3, {
            key: tabIndex,
            colStart: tabIndex + 1,
            rowStart: setGridRow(monthTab.temperature.max),
            rowSpan: "all",
            rowEnd: setGridRow(monthTab.temperature.min)
        }, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(DestinationTemperature, {
            onClick: function() {
                return handleTabChangeFunc(tabIndex, true);
            },
            data: monthTab.temperature,
            selected: monthList.indexOf(monthTab) === selectedTabIndex + tabIndexDelta
        }))), monthList.indexOf(monthTab) === selectedTabIndex + tabIndexDelta && getVerticalLine(tabIndex, totalRows + additionalRows + 1, setGridRow(monthTab.temperature.min) + additionalRows - rowDelta));
    };
    var onIndexChange = function(index) {
        setSelectedTabIndexState(0);
        carouselIndex.current = index;
    };
    var setGridRow = function(getTemp) {
        var maxTemperatureOverAll = maxTemperature(monthsTabs);
        return maxTemperatureOverAll - getTemp;
    };
    var getVerticalLine = function(tabIndex, row, indexNumber) {
        var lines = [];
        var setIndex = indexNumber || 0;
        for(var index = setIndex; index < row; index++){
            lines.push(/* @__PURE__ */ React13.createElement(UitkLayoutGridItem3, {
                rowStart: index,
                colStart: tabIndex + 1
            }, /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(YAxisLine, null)))));
        }
        return lines;
    };
    var carouselProps = {
        navigationIconId: {
            next: "next-button-gallery-inset-pagination-dots",
            prev: "prev-button-gallery-inset-pagination-dots"
        },
        buttonText: {
            nextButton: "Show next card",
            prevButton: "Show previous card"
        },
        wrapItems: true,
        itemsVisible: {
            sm: 1,
            md: 1,
            lg: 1
        },
        pageBy: 1,
        peek: false,
        onIndexChange: onIndexChange,
        pagingPersistent: true
    };
    var getUitkTabsProp = function(onTabClickCBFunc) {
        return {
            onTabClickCB: onTabClickCBFunc,
            selectedTab: selectedTabIndex,
            tabsType: UitkTabsType.EQUAL_WIDTH,
            role: "tablist",
            withBorder: true
        };
    };
    return isScrollable ? /* @__PURE__ */ React13.createElement(UitkScrollable, {
        direction: "horizontal",
        tag: "section"
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        direction: "column",
        style: {
            width: "400%"
        }
    }, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            inline: "four"
        }
    }, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(UitkTabs, _object_spread({}, getUitkTabsProp(handleTabChange)), monthsTabs.map(function(monthTab, tabIndex) {
        return /* @__PURE__ */ React13.createElement(UitkTab, {
            name: monthTab.label,
            key: "monthTab".concat(tabIndex),
            targetURI: "monthTab".concat(tabIndex)
        });
    })), /* @__PURE__ */ React13.createElement(UitkLayoutPosition, {
        type: "absolute"
    }, /* @__PURE__ */ React13.createElement("div", null, monthsTabs[selectedTabIndex].accessibility && /* @__PURE__ */ React13.createElement("span", {
        className: "is-visually-hidden"
    }, monthsTabs[selectedTabIndex].accessibility), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            blockstart: "two",
            inlineend: "three"
        }
    }, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(MonthsForecastTab, {
        data: monthsTabs[selectedTabIndex]
    }))), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            blockstart: "three",
            inlineend: "three"
        }
    }, /* @__PURE__ */ React13.createElement(UitkText4, null, monthsTabs[selectedTabIndex].description)))), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            blockstart: "sixteen"
        },
        padding: {
            blockstart: "four"
        },
        style: {
            height: sectionHeight
        }
    }, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(UitkLayoutGrid3, {
        columns: [
            Repeat(monthsTabs.length / 3, "1fr")
        ],
        rows: totalRows + additionalRows,
        blockSize: "full_size"
    }, monthsTabs.map(function(monthTab, tabIndex) {
        return getDestinationTemperature(monthsTabs, monthTab, tabIndex, handleTabChange, 2);
    })))))))) : /* @__PURE__ */ React13.createElement(Viewport, null, /* @__PURE__ */ React13.createElement(ViewSmall, null, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            inline: "two"
        }
    }, /* @__PURE__ */ React13.createElement(UitkCarousel, _object_spread({}, carouselProps), /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React13.createElement(UitkTabs, _object_spread({}, getUitkTabsProp(handleTabChangeSmall)), monthsTabs.slice(0, 5).map(function(monthTab, tabIndex) {
        return getTab(monthTab, tabIndex);
    })), monthsTabs[selectedTabIndex].accessibility && /* @__PURE__ */ React13.createElement("span", {
        className: "is-visually-hidden"
    }, monthsTabs[selectedTabIndex].accessibility), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            blockstart: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React13.createElement(UitkText4, null, monthsTabs[selectedTabIndex].description)), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            inline: "one"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React13.createElement("div", {
        style: {
            height: sectionHeight
        }
    }, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutGrid3, {
        columns: [
            Repeat(monthsTabs.length / 3, "1fr")
        ],
        rows: totalRows + additionalRows,
        blockSize: "full_size"
    }, monthsTabs.slice(0, 5).map(function(monthTab, tabIndex) {
        return getDestinationTemperature(monthsTabs, monthTab, tabIndex, handleTabChangeSmall, 1);
    }))))))), /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React13.createElement(UitkTabs, _object_spread({}, getUitkTabsProp(handleTabChangeSmall)), monthsTabs.slice(5, 10).map(function(monthTab, tabIndex) {
        return getTab(monthTab, tabIndex);
    })), monthsTabs[selectedTabIndex].accessibility && /* @__PURE__ */ React13.createElement("span", {
        className: "is-visually-hidden"
    }, monthsTabs[selectedTabIndex].accessibility), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            blockstart: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React13.createElement(UitkText4, null, monthsTabs[selectedTabIndex].description)), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            inline: "one"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React13.createElement("div", {
        style: {
            height: sectionHeight
        }
    }, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutGrid3, {
        columns: [
            Repeat(monthsTabs.length / 3, "1fr")
        ],
        rows: totalRows + additionalRows,
        blockSize: "full_size"
    }, monthsTabs.slice(5, 10).map(function(monthTab, tabIndex) {
        return getDestinationTemperature(monthsTabs, monthTab, tabIndex, handleTabChangeSmall, 1, 5);
    }))))))), /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React13.createElement(UitkTabs, _object_spread({}, getUitkTabsProp(handleTabChangeSmall)), lastCarouselItemList.map(function(monthTab, tabIndex) {
        return getTab(monthTab, tabIndex);
    })), ((_lastCarouselItemList_selectedTabIndex = lastCarouselItemList[selectedTabIndex]) === null || _lastCarouselItemList_selectedTabIndex === void 0 ? void 0 : _lastCarouselItemList_selectedTabIndex.accessibility) && /* @__PURE__ */ React13.createElement("span", {
        className: "is-visually-hidden"
    }, lastCarouselItemList[selectedTabIndex].accessibility), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            blockstart: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React13.createElement(UitkText4, null, (_lastCarouselItemList_selectedTabIndex1 = lastCarouselItemList[selectedTabIndex]) === null || _lastCarouselItemList_selectedTabIndex1 === void 0 ? void 0 : _lastCarouselItemList_selectedTabIndex1.description)), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            inline: "one"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React13.createElement("div", {
        style: {
            height: sectionHeight
        }
    }, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutGrid3, {
        columns: [
            Repeat(monthsTabs.length / 3, "1fr")
        ],
        rows: totalRows + additionalRows,
        blockSize: "full_size"
    }, lastCarouselItemList.map(function(monthTab, tabIndex) {
        return getDestinationTemperature(lastCarouselItemList, monthTab, tabIndex, handleTabChangeSmall, 1);
    })))))))))), /* @__PURE__ */ React13.createElement(ViewMedium, null, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            inline: "two"
        }
    }, /* @__PURE__ */ React13.createElement(UitkCarousel, _object_spread({}, carouselProps), /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React13.createElement(UitkTabs, _object_spread({}, getUitkTabsProp(handleTabChange)), monthsTabs.slice(0, 7).map(function(monthTab, tabIndex) {
        return getTab(monthTab, tabIndex);
    })), monthsTabs[selectedTabIndex].accessibility && /* @__PURE__ */ React13.createElement("span", {
        className: "is-visually-hidden"
    }, monthsTabs[selectedTabIndex].accessibility), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            blockstart: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React13.createElement(UitkText4, null, monthsTabs[selectedTabIndex].description)), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            inline: "one"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React13.createElement("div", {
        style: {
            height: sectionHeight
        }
    }, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutGrid3, {
        columns: [
            Repeat(monthsTabs.length / 3, "1fr")
        ],
        rows: totalRows + additionalRows,
        blockSize: "full_size"
    }, monthsTabs.slice(0, 7).map(function(monthTab, tabIndex) {
        return getDestinationTemperature(monthsTabs, monthTab, tabIndex, handleTabChange, 1);
    }))))))), /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React13.createElement(UitkTabs, _object_spread({}, getUitkTabsProp(handleTabChange)), lastCarouselItemsTabList.map(function(monthTab, tabIndex) {
        return getTab(monthTab, tabIndex);
    })), ((_lastCarouselItemsTabList_selectedTabIndex = lastCarouselItemsTabList[selectedTabIndex]) === null || _lastCarouselItemsTabList_selectedTabIndex === void 0 ? void 0 : _lastCarouselItemsTabList_selectedTabIndex.accessibility) && /* @__PURE__ */ React13.createElement("span", {
        className: "is-visually-hidden"
    }, lastCarouselItemsTabList[selectedTabIndex].accessibility), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            blockstart: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React13.createElement(UitkText4, null, (_lastCarouselItemsTabList_selectedTabIndex1 = lastCarouselItemsTabList[selectedTabIndex]) === null || _lastCarouselItemsTabList_selectedTabIndex1 === void 0 ? void 0 : _lastCarouselItemsTabList_selectedTabIndex1.description)), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            inline: "one"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React13.createElement("div", {
        style: {
            height: sectionHeight
        }
    }, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutGrid3, {
        columns: [
            Repeat(monthsTabs.length / 3, "1fr")
        ],
        rows: totalRows + additionalRows,
        blockSize: "full_size"
    }, lastCarouselItemsTabList.map(function(monthTab, tabIndex) {
        return getDestinationTemperature(lastCarouselItemsTabList, monthTab, tabIndex, handleTabChange, 1);
    })))))))))), /* @__PURE__ */ React13.createElement(ViewLarge, null, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        direction: "column"
    }, /* @__PURE__ */ React13.createElement(UitkTabs, _object_spread({}, getUitkTabsProp(handleTabChange)), monthsTabs.map(function(monthTab, tabIndex) {
        return getTab(monthTab, tabIndex, {
            blockstart: "two",
            inline: "three"
        });
    })), monthsTabs[selectedTabIndex].accessibility && /* @__PURE__ */ React13.createElement("span", {
        className: "is-visually-hidden"
    }, monthsTabs[selectedTabIndex].accessibility), /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            blockstart: "three",
            inline: "three",
            blockend: "six"
        }
    }, /* @__PURE__ */ React13.createElement(UitkText4, null, monthsTabs[selectedTabIndex].description)), /* @__PURE__ */ React13.createElement("div", {
        style: {
            height: sectionHeight
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutGrid3, {
        columns: [
            Repeat(monthsTabs.length / 3, "1fr")
        ],
        rows: totalRows + additionalRows,
        blockSize: "full_size"
    }, monthsTabs.map(function(monthTab, tabIndex) {
        return getDestinationTemperature(monthsTabs, monthTab, tabIndex, handleTabChange, 2);
    })))))));
};
MonthsForecastsTabs.displayName = "MonthsForecastsTabs";
MonthsForecastsTabs.fragment = __Fragment4;
// src/components/destination-guide-best-time-to-go/__private/destination-monthly-historical-forecast/destination-monthly-historical-forecast.tsx
var fragment4 = gql13(_templateObject12(), MonthsForecastsTabs.fragment, EGDSStandardMessagingCard.fragment);
var DestinationMonthlyHistoricalForecast = function(param) {
    var customHeight = param.customHeight, isScrollable = param.isScrollable, data = param.data;
    var actions = data.actions, monthsForecast = data.monthsForecast, description = data.description;
    return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(MonthsForecastsTabs, {
        data: monthsForecast,
        customHeight: customHeight,
        isScrollable: isScrollable
    }), /* @__PURE__ */ React14.createElement(UitkSpacing7, {
        padding: {
            large: {
                inline: "three",
                block: isScrollable ? "one" : "six"
            },
            medium: {
                inline: "three",
                block: isScrollable ? "one" : "six"
            },
            small: {
                block: isScrollable ? "one" : "six",
                inline: isScrollable ? "three" : "unset"
            }
        }
    }, /* @__PURE__ */ React14.createElement(UitkText5, null, description), monthsForecast.accessibility && /* @__PURE__ */ React14.createElement("span", {
        className: "is-visually-hidden"
    }, monthsForecast.accessibility)), /* @__PURE__ */ React14.createElement(UitkSpacing7, {
        padding: {
            large: {
                inlineend: "three"
            },
            medium: {
                inlineend: "three"
            }
        }
    }, /* @__PURE__ */ React14.createElement(UitkLayoutGrid4, {
        columns: {
            large: 2,
            medium: 2,
            small: 1
        }
    }, actions.map(function(action, index) {
        return /* @__PURE__ */ React14.createElement(UitkLayoutGridItem4, {
            key: index
        }, /* @__PURE__ */ React14.createElement(UitkSpacing7, {
            padding: {
                large: {
                    blockend: "three",
                    inlinestart: "three"
                },
                medium: {
                    blockend: "three",
                    inlinestart: "three"
                },
                small: {
                    blockend: "three"
                }
            }
        }, /* @__PURE__ */ React14.createElement("div", null, action.links && /* @__PURE__ */ React14.createElement("span", {
            className: "is-visually-hidden"
        }, action.links[0].action.accessibility), /* @__PURE__ */ React14.createElement(EGDSStandardMessagingCard, {
            data: action
        }))));
    }))));
};
DestinationMonthlyHistoricalForecast.fragment = fragment4;
DestinationMonthlyHistoricalForecast.displayName = "DestinationMonthlyHistoricalForecast";
// src/components/destination-insights-monthly-details/destination-insights-monthly-details.tsx
import React22, { useCallback, useRef } from "react";
import { gql as gql24 } from "@apollo/client";
import { ChartLine } from "@egds/react-acquisition-marketing-growth-landing";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard3 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid5, UitkLayoutGridItem as UitkLayoutGridItem5 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
// src/utils/fragments/destination-insights-price-monthly-data/destination-insights-price-monthly-data.tsx
import { gql as gql16 } from "@apollo/client";
// src/utils/fragments/client-side-analytics-fragment.ts
import { gql as gql14 } from "@apollo/client";
import { ITrackType } from "@shared-ui/clickstream-analytics-context";
var ClientSideAnalyticsFragment = gql14(_templateObject13());
var trackAnalytics = function(clickstreamAnalytics, analytic) {
    var track = clickstreamAnalytics.track;
    var eventType = analytic.eventType, linkName = analytic.linkName, referrerId = analytic.referrerId;
    var messages = [];
    var _eventType_toLowerCase;
    messages.push({
        schemaName: "referrer",
        messageContent: {
            eventType: (_eventType_toLowerCase = eventType === null || eventType === void 0 ? void 0 : eventType.toLowerCase()) !== null && _eventType_toLowerCase !== void 0 ? _eventType_toLowerCase : "click",
            linkName: linkName,
            referrerId: referrerId
        }
    });
    track(ITrackType.EVENT, {
        data: messages
    });
};
// src/utils/fragments/destination-insights-price/destination-insights-price.tsx
import { gql as gql15 } from "@apollo/client";
var DestinationInsightsPriceFragment = gql15(_templateObject14());
// src/utils/fragments/destination-insights-price-monthly-data/destination-insights-price-monthly-data.tsx
var DestinationInsightsMonthlyDataFragment = gql16(_templateObject15(), DestinationInsightsPriceFragment, ClientSideAnalyticsFragment);
// src/components/destination-insights-tooltip/destination-insights-tooltip.tsx
import React21, { useState as useState2 } from "react";
import { gql as gql23 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkIcon as UitkIcon4 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkText as UitkText10 } from "uitk-react-text";
// src/components/egds-sheet/egds-sheet.tsx
import React15 from "react";
import { gql as gql17 } from "@apollo/client";
import { useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
import { UitkSheet, UitkSheetContent, UitkSheetTransition } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
var _obj2;
// src/components/egds-sheet/__private/sheet-type.ts
var sheetTypeMapper = (_obj2 = {}, _define_property(_obj2, "BOTTOM" /* BOTTOM */ , "bottom"), _define_property(_obj2, "CENTERED" /* CENTERED */ , "centered"), _define_property(_obj2, "FULLSCREEN" /* FULLSCREEN */ , "full"), _define_property(_obj2, "POPOVER" /* POPOVER */ , "popover"), _define_property(_obj2, "SIDE" /* SIDE */ , "side"), _obj2);
// src/components/egds-sheet/egds-sheet.tsx
var fragment5 = gql17(_templateObject16(), ClientSideAnalyticsFragment);
var EGDSSheet = function(param) {
    var children = param.children, data = param.data, isVisible = param.isVisible, handleClose = param.handleClose, closeIcon = param.closeIcon;
    var clickstreamAnalytics = useClickstreamAnalytics();
    var closeAnalytics = data.closeAnalytics, closeText = data.closeText, sheetType = data.sheetType;
    var handleSheetClose = function() {
        handleClose === null || handleClose === void 0 ? void 0 : handleClose();
        trackAnalytics(clickstreamAnalytics, closeAnalytics);
    };
    var tooltipPosition = sheetType === "POPOVER" ? {
        inline: "leading",
        block: "trailing"
    } : void 0;
    var navIconLabel = (closeIcon === null || closeIcon === void 0 ? void 0 : closeIcon.description) || closeText || "";
    return /* @__PURE__ */ React15.createElement(UitkSheetTransition, {
        isVisible: isVisible
    }, /* @__PURE__ */ React15.createElement(UitkSheet, {
        position: tooltipPosition,
        isVisible: isVisible,
        type: sheetType ? sheetTypeMapper[sheetType] : void 0,
        triggerRef: null
    }, /* @__PURE__ */ React15.createElement(UitkToolbar, {
        navigationContent: {
            onClick: handleSheetClose,
            navIconLabel: navIconLabel
        },
        toolbarTitle: closeText || ""
    }), /* @__PURE__ */ React15.createElement(UitkSheetContent, {
        fullSheetContentMaxWidth: "extra-large"
    }, children)));
};
EGDSSheet.displayName = "EGDSSheet";
EGDSSheet.fragment = fragment5;
// src/components/egds-spannable-text/egds-spannable-text.tsx
import React20 from "react";
import { gql as gql22 } from "@apollo/client";
import { UitkText as UitkText9 } from "uitk-react-text";
// src/components/egds-spannable-text/__private/egds-spannable-text-content.tsx
import React19 from "react";
import { gql as gql21 } from "@apollo/client";
// src/components/egds-spannable-text/__private/egds-graphic-text.tsx
import React16 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkText as UitkText6 } from "uitk-react-text";
var fragment6 = gql18(_templateObject17(), UiGraphic.fragment);
var textPadding = {
    inlinestart: "one"
};
var graphicPadding = {
    inlineend: "one"
};
var EGDSGraphicText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, data = param.data, padding = param.padding;
    var text = data.text, graphic = data.graphic;
    return /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(UitkSpacing8, {
        padding: graphicPadding
    }, /* @__PURE__ */ React16.createElement(UiGraphic, {
        data: graphic,
        padding: padding
    })), /* @__PURE__ */ React16.createElement(UitkSpacing8, {
        padding: textPadding
    }, /* @__PURE__ */ React16.createElement(UitkText6, {
        className: className,
        inline: inline,
        size: size
    }, text)));
};
EGDSGraphicText.fragment = fragment6;
EGDSGraphicText.displayName = "EGDSGraphicText";
// src/components/egds-spannable-text/__private/egds-plain-text.tsx
import React17 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkText as UitkText7 } from "uitk-react-text";
var fragment7 = gql19(_templateObject18());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, align = param.align, size = param.size, theme = param.theme, data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React17.createElement(UitkText7, {
        className: className,
        align: align,
        size: size,
        inline: inline,
        theme: theme
    }, text);
};
EGDSPlainText.fragment = fragment7;
EGDSPlainText.displayName = "EGDSPlainText";
// src/components/egds-spannable-text/__private/egds-stylized-text.tsx
import React18 from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkText as UitkText8 } from "uitk-react-text";
var _obj3;
// src/components/egds-spannable-text/__private/text-theme.ts
var textThemeMapper = (_obj3 = {}, _define_property(_obj3, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj3, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj3, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj3, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj3, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj3, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj3, "INVERSE" /* INVERSE */ , "inverse"), _obj3);
var _obj4;
// src/components/egds-spannable-text/__private/text-weight.ts
var textWeightMapper = (_obj4 = {}, _define_property(_obj4, "BOLD" /* BOLD */ , "bold"), _define_property(_obj4, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj4, "REGULAR" /* REGULAR */ , "regular"), _obj4);
// src/components/egds-spannable-text/__private/egds-stylized-text.tsx
var fragment8 = gql20(_templateObject19());
var EGDSStylizedText = function(param) {
    var className = param.className, inline = param.inline, align = param.align, size = param.size, data = param.data;
    var text = data.text, theme = data.theme, weight = data.weight, accessibility = data.accessibility, decorative = data.decorative;
    var themeProps = theme ? textThemeMapper[theme] : void 0;
    var weightProps = weight ? textWeightMapper[weight] : void 0;
    switch(decorative){
        case "LINE_THROUGH" /* LINE_THROUGH */ :
            return /* @__PURE__ */ React18.createElement("s", null, /* @__PURE__ */ React18.createElement(UitkText8, {
                className: className,
                align: align,
                inline: inline,
                size: size,
                theme: themeProps,
                weight: weightProps,
                "aria-hidden": accessibility !== null
            }, text), accessibility && /* @__PURE__ */ React18.createElement("span", {
                className: "is-visually-hidden"
            }, accessibility));
        default:
            return /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement(UitkText8, {
                className: className,
                align: align,
                inline: inline,
                size: size,
                theme: themeProps,
                weight: weightProps,
                "aria-hidden": accessibility !== null
            }, text), accessibility && /* @__PURE__ */ React18.createElement("span", {
                className: "is-visually-hidden"
            }, accessibility));
    }
};
EGDSStylizedText.fragment = fragment8;
EGDSStylizedText.displayName = "EGDSStylizedText";
// src/components/egds-spannable-text/__private/egds-spannable-text-content.tsx
var fragment9 = gql21(_templateObject20(), EGDSPlainText.fragment, EGDSGraphicText.fragment, EGDSStylizedText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, align = param.align, theme = param.theme, data = param.data, padding = param.padding;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React19.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                align: align,
                inline: true,
                theme: theme
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React19.createElement(EGDSGraphicText, {
                className: className,
                data: data,
                inline: true,
                padding: padding
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React19.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                align: align,
                inline: true
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment9;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// src/components/egds-spannable-text/egds-spannable-text.tsx
var fragment10 = gql22(_templateObject21(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_inlineContent;
    var align = props.align, data = props.data, theme = props.theme, styleProps = _object_without_properties(props, [
        "align",
        "data",
        "theme"
    ]);
    if (!(data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length) && data.text) {
        return /* @__PURE__ */ React20.createElement(UitkText9, _object_spread_props(_object_spread({}, styleProps), {
            inline: true,
            align: align,
            theme: theme
        }), data.text);
    }
    return /* @__PURE__ */ React20.createElement(React20.Fragment, null, data.inlineContent.map(function(item, index) {
        return /* @__PURE__ */ React20.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
            align: align,
            data: item
        }, styleProps), {
            key: "spannable-item-".concat(index),
            theme: theme
        }));
    }));
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";
// src/components/destination-insights-tooltip/destination-insights-tooltip.tsx
var _Fragment2 = gql23(_templateObject22(), EGDSSheet.fragment, EGDSSpannableText.fragment, EGDSButton.fragment);
var DestinationInsightsTooltip = function(param) {
    var data = param.data, triggerText = param.triggerText, closeTooltipOnClick = param.closeTooltipOnClick, externalDivRef = param.externalDivRef, destinationInsightsTooltipMargin = param.destinationInsightsTooltipMargin, _param_textSize = param.textSize, textSize = _param_textSize === void 0 ? 300 : _param_textSize;
    var actionRef = React21.useRef(null);
    var _useState2 = _sliced_to_array(useState2(false), 2), isTooltipVisible = _useState2[0], setIsTooltipVisible = _useState2[1];
    var tooltipSheet = data.tooltipSheet, content = data.content, closeIcon = data.closeIcon, button = data.button;
    var track = useClickTracker6();
    var handleClose = function() {
        setIsTooltipVisible(false);
    };
    var handleTooltipClick = function() {
        setIsTooltipVisible(!isTooltipVisible);
        if (button.analytics) {
            track(button.analytics.referrerId, button.analytics.linkName);
        }
    };
    var handleClickOutside = function(event) {
        var _actionRef_current;
        if (isTooltipVisible && !((_actionRef_current = actionRef.current) === null || _actionRef_current === void 0 ? void 0 : _actionRef_current.contains(event.target)) && closeTooltipOnClick) {
            handleClose();
        }
    };
    React21.useEffect(function() {
        if (closeTooltipOnClick) {
            var _externalDivRef_current;
            var externalRef = externalDivRef === null || externalDivRef === void 0 ? void 0 : externalDivRef.current;
            var externalRefChildren = externalDivRef === null || externalDivRef === void 0 ? void 0 : (_externalDivRef_current = externalDivRef.current) === null || _externalDivRef_current === void 0 ? void 0 : _externalDivRef_current.children;
            document.body.addEventListener("click", handleClickOutside);
            window.addEventListener("scroll", handleClickOutside);
            if (externalRef) {
                externalRef.addEventListener("scroll", handleClickOutside);
            }
            if (externalRefChildren === null || externalRefChildren === void 0 ? void 0 : externalRefChildren.length) {
                Array.from(externalRefChildren).forEach(function(child) {
                    if (child) {
                        child.addEventListener("scroll", handleClickOutside);
                    }
                });
            }
            return function() {
                document.body.removeEventListener("click", handleClickOutside);
                window.removeEventListener("scroll", handleClickOutside);
                if (externalRef) {
                    externalRef.removeEventListener("scroll", handleClickOutside);
                }
                if (externalRefChildren === null || externalRefChildren === void 0 ? void 0 : externalRefChildren.length) {
                    Array.from(externalRefChildren).forEach(function(child) {
                        if (child) {
                            child.removeEventListener("scroll", handleClickOutside);
                        }
                    });
                }
            };
        }
    }, [
        setIsTooltipVisible,
        isTooltipVisible,
        externalDivRef
    ]);
    return /* @__PURE__ */ React21.createElement(React21.Fragment, null, /* @__PURE__ */ React21.createElement(UitkLayoutFlex6, null, /* @__PURE__ */ React21.createElement(UitkLayoutFlexItem6, {
        alignSelf: "center"
    }, /* @__PURE__ */ React21.createElement("div", null, triggerText && /* @__PURE__ */ React21.createElement(UitkText10, {
        size: textSize
    }, triggerText))), /* @__PURE__ */ React21.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React21.createElement(UitkSpacing9, {
        margin: destinationInsightsTooltipMargin
    }, /* @__PURE__ */ React21.createElement("div", {
        ref: actionRef
    }, /* @__PURE__ */ React21.createElement(UitkTertiaryButton2, {
        size: UitkButtonSize.SMALL,
        type: "button",
        onClick: handleTooltipClick
    }, /* @__PURE__ */ React21.createElement(UitkIcon4, {
        theme: "default",
        name: "info_outline",
        id: "info_outline",
        description: button.accessibility || "",
        title: button.accessibility || ""
    })))))), /* @__PURE__ */ React21.createElement(EGDSSheet, {
        closeIcon: closeIcon,
        data: tooltipSheet,
        isVisible: isTooltipVisible,
        handleClose: handleClose
    }, /* @__PURE__ */ React21.createElement(EGDSSpannableText, {
        data: content
    })));
};
DestinationInsightsTooltip.fragment = _Fragment2;
DestinationInsightsTooltip.displayName = "DestinationInsightsTooltip";
// src/components/destination-insights-monthly-details/destination-insights-monthly-details.tsx
var _Fragment3 = gql24(_templateObject23(), DestinationInsightsTooltip.fragment, DestinationInsightsMonthlyDataFragment);
var DestinationInsightsMonthlyDetails = function(param) {
    var data = param.data, rangeIndicator = param.rangeIndicator, customId = param.customId, _param_isMobileContainerCustomWidth = param.isMobileContainerCustomWidth, isMobileContainerCustomWidth = _param_isMobileContainerCustomWidth === void 0 ? "100vw" : _param_isMobileContainerCustomWidth, _param_isMobileSvgCustomWidth = param.isMobileSvgCustomWidth, isMobileSvgCustomWidth = _param_isMobileSvgCustomWidth === void 0 ? "200vw" : _param_isMobileSvgCustomWidth, _param_forceMobileView = param.forceMobileView, forceMobileView = _param_forceMobileView === void 0 ? false : _param_forceMobileView, _param_isMobileGraphCustomWidth = param.isMobileGraphCustomWidth, isMobileGraphCustomWidth = _param_isMobileGraphCustomWidth === void 0 ? 600 : _param_isMobileGraphCustomWidth, _param_isMobileGraphCustomHeight = param.isMobileGraphCustomHeight, isMobileGraphCustomHeight = _param_isMobileGraphCustomHeight === void 0 ? 300 : _param_isMobileGraphCustomHeight, _param_removeMobileGraphSpacing = param.removeMobileGraphSpacing, removeMobileGraphSpacing = _param_removeMobileGraphSpacing === void 0 ? false : _param_removeMobileGraphSpacing, _param_isMobileCurrentMonthInitialIndex = param.isMobileCurrentMonthInitialIndex, isMobileCurrentMonthInitialIndex = _param_isMobileCurrentMonthInitialIndex === void 0 ? false : _param_isMobileCurrentMonthInitialIndex, _param_mobileCustomVerticalTicks = param.mobileCustomVerticalTicks, mobileCustomVerticalTicks = _param_mobileCustomVerticalTicks === void 0 ? 6 : _param_mobileCustomVerticalTicks, customMax = param.customMax, customMin = param.customMin, _param_xTickPadding = param.xTickPadding, xTickPadding = _param_xTickPadding === void 0 ? 30 : _param_xTickPadding, _param_yTickPadding = param.yTickPadding, yTickPadding = _param_yTickPadding === void 0 ? 10 : _param_yTickPadding, _param_customGraphStyle = param.customGraphStyle, customGraphStyle = _param_customGraphStyle === void 0 ? {
        margin: "0 -30px -30px 0",
        overflow: "hidden"
    } : _param_customGraphStyle, customYFontSize = param.customYFontSize, customXFontSize = param.customXFontSize, customTickTextFontSize = param.customTickTextFontSize, _param_addYMinMaxLimit = param.addYMinMaxLimit, addYMinMaxLimit = _param_addYMinMaxLimit === void 0 ? false : _param_addYMinMaxLimit, _param_closeTooltipOnClick = param.closeTooltipOnClick, closeTooltipOnClick = _param_closeTooltipOnClick === void 0 ? false : _param_closeTooltipOnClick, _param_destinationInsightsTooltipMargin = param.destinationInsightsTooltipMargin, destinationInsightsTooltipMargin = _param_destinationInsightsTooltipMargin === void 0 ? {
        inline: "three"
    } : _param_destinationInsightsTooltipMargin, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? 6 : _param_headingSize, _param_textSize = param.textSize, textSize = _param_textSize === void 0 ? 300 : _param_textSize, customAccessibilityRadius = param.customAccessibilityRadius;
    var graphRef = React22.useRef(null);
    var title = data.title, subtitle = data.subtitle, tooltip = data.tooltip, monthlyData = data.monthlyData, accessibility = data.accessibility;
    var currentMonthIndex = monthlyData.findIndex(function(month) {
        return month.selected;
    });
    var xAxisValues = monthlyData.map(function(month) {
        return month.label;
    });
    var yAxisValues = monthlyData.map(function(month) {
        return month.averagePrice.priceAsNumber;
    });
    var yAxisTexts = monthlyData.map(function(month) {
        return month.averagePrice.priceAsText;
    });
    var accessibilyLabels = monthlyData.map(function(month) {
        return month.accessibility || month.monthName;
    });
    var seriesData = {
        name: "",
        data: yAxisValues
    };
    var firstPrice = monthlyData[0].averagePrice;
    var yDataAdditionalInfoLeft = firstPrice.priceAsText.startsWith(firstPrice.currency) ? firstPrice.currency : "";
    var yDataAdditionalInfoRight = firstPrice.priceAsText.endsWith(firstPrice.currency) ? firstPrice.currency : "";
    var mobileInitialIndex = currentMonthIndex > 2 ? currentMonthIndex - 2 : 10 - currentMonthIndex;
    if (isMobileCurrentMonthInitialIndex) {
        mobileInitialIndex = currentMonthIndex;
    }
    var seriesDataBeforeCurrentMonth = seriesData.data.slice(0, mobileInitialIndex);
    var xAxisBeforeCurrentMonth = xAxisValues.slice(0, mobileInitialIndex);
    var yAxisTextsBeforeCurrentMonth = yAxisTexts.slice(0, mobileInitialIndex);
    var seriesDataFromCurrentMonth = seriesData.data.slice(mobileInitialIndex, seriesData.data.length);
    var xAxisFromCurrentMonth = xAxisValues.slice(mobileInitialIndex, xAxisValues.length);
    var yAxisTextsDataFromCurrentMonth = yAxisTexts.slice(mobileInitialIndex, yAxisTexts.length);
    var mobileSeriesData = seriesDataFromCurrentMonth.concat(seriesDataBeforeCurrentMonth);
    var mobileXAxis = xAxisFromCurrentMonth.concat(xAxisBeforeCurrentMonth);
    var mobileYAxisText = yAxisTextsDataFromCurrentMonth.concat(yAxisTextsBeforeCurrentMonth);
    var track = useClickTracker7();
    var isFirstMonthClick = useRef(true);
    var isFirstRendering = useRef(true);
    var selectedMonth = useRef(currentMonthIndex);
    var needToTrack = useCallback(function(event) {
        var index = event.target.__data__.date;
        if (index !== selectedMonth.current) {
            selectedMonth.current = index;
            if (!isFirstRendering.current) {
                isFirstMonthClick.current = false;
            } else {
                isFirstRendering.current = false;
            }
        } else {
            isFirstMonthClick.current = true;
        }
        if (!isFirstMonthClick.current) {
            var ref = monthlyData[index].click.referrerId;
            var link = monthlyData[index].click.linkName;
            track(ref, link);
        }
    }, [
        isFirstMonthClick,
        isFirstRendering
    ]);
    var handleMonthClick = useCallback(function(event) {
        needToTrack(event);
    }, []);
    var smallViewportGraph = /* @__PURE__ */ React22.createElement(ChartLine, {
        xAxisProp: mobileXAxis,
        seriesData: mobileSeriesData,
        initialIndex: isMobileCurrentMonthInitialIndex ? 0 : 2,
        lineChartDataAsTextProp: mobileYAxisText,
        yDataAdditionalInfoLeft: yDataAdditionalInfoLeft,
        yDataAdditionalInfoRight: yDataAdditionalInfoRight,
        chartId: "".concat(customId, "insights-chart-mobile"),
        customVerticalTicks: mobileCustomVerticalTicks,
        customHeight: isMobileGraphCustomHeight,
        customWidth: isMobileGraphCustomWidth,
        onChangeXIndex: handleMonthClick,
        isMobile: true,
        customCircleRadius: 7,
        customCircleRadiusOver: 8,
        xAxisAccessibilityLabels: accessibilyLabels,
        accessibilityChartTitle: accessibility || "",
        isMobileContainerCustomWidth: isMobileContainerCustomWidth,
        isMobileSvgCustomWidth: isMobileSvgCustomWidth,
        customMax: customMax,
        customMin: customMin,
        xTickPadding: xTickPadding,
        yTickPadding: yTickPadding,
        customGraphStyle: customGraphStyle,
        addYMinMaxLimit: addYMinMaxLimit,
        customYFontSize: customYFontSize,
        customXFontSize: customXFontSize,
        customTickTextFontSize: customTickTextFontSize,
        customAccessibilityRadius: customAccessibilityRadius
    });
    var graph = /* @__PURE__ */ React22.createElement(Viewport2, null, /* @__PURE__ */ React22.createElement(ViewSmall2, null, /* @__PURE__ */ React22.createElement("div", {
        ref: graphRef
    }, accessibility && /* @__PURE__ */ React22.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility), smallViewportGraph)), /* @__PURE__ */ React22.createElement(ViewMedium2, null, /* @__PURE__ */ React22.createElement(UitkCard3, {
        backgroundTheme: "primary",
        border: !forceMobileView
    }, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(UitkSpacing10, null, /* @__PURE__ */ React22.createElement("div", {
        ref: graphRef
    }, accessibility && /* @__PURE__ */ React22.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility), forceMobileView ? smallViewportGraph : /* @__PURE__ */ React22.createElement(ChartLine, {
        xAxisProp: xAxisValues,
        seriesData: seriesData.data,
        initialIndex: currentMonthIndex,
        lineChartDataAsTextProp: yAxisTexts,
        yDataAdditionalInfoLeft: yDataAdditionalInfoLeft,
        yDataAdditionalInfoRight: yDataAdditionalInfoRight,
        chartId: "".concat(customId, "insights-chart"),
        customVerticalTicks: 6,
        onChangeXIndex: handleMonthClick,
        customCircleRadius: 8,
        customCircleRadiusOver: 10,
        xAxisAccessibilityLabels: accessibilyLabels,
        accessibilityChartTitle: accessibility || ""
    })))))));
    var mobileBlockStartTitle = removeMobileGraphSpacing ? "unset" : "one";
    var mobileBlockStartSubTitle = removeMobileGraphSpacing ? "unset" : "four";
    return /* @__PURE__ */ React22.createElement(UitkSpacing10, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(UitkSpacing10, {
        padding: {
            blockstart: removeMobileGraphSpacing ? "unset" : "three",
            inline: "three"
        }
    }, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(Viewport2, null, /* @__PURE__ */ React22.createElement(ViewSmall2, null, /* @__PURE__ */ React22.createElement(UitkHeading4, {
        size: headingSize,
        tag: "h2"
    }, title)), /* @__PURE__ */ React22.createElement(ViewMedium2, null, /* @__PURE__ */ React22.createElement(UitkHeading4, {
        size: forceMobileView ? headingSize : 4,
        tag: "h2"
    }, title))))), /* @__PURE__ */ React22.createElement(UitkSpacing10, {
        padding: {
            small: {
                blockstart: "one"
            },
            medium: {
                blockstart: forceMobileView ? mobileBlockStartTitle : "six"
            }
        }
    }, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(UitkSpacing10, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(DestinationInsightsTooltip, {
        data: tooltip,
        triggerText: subtitle,
        closeTooltipOnClick: closeTooltipOnClick,
        externalDivRef: graphRef,
        destinationInsightsTooltipMargin: destinationInsightsTooltipMargin,
        textSize: textSize
    }))), /* @__PURE__ */ React22.createElement(UitkSpacing10, {
        padding: {
            small: {
                blockstart: "four"
            },
            medium: {
                blockstart: forceMobileView ? mobileBlockStartSubTitle : "two",
                inline: forceMobileView ? "unset" : "three"
            }
        }
    }, /* @__PURE__ */ React22.createElement(UitkLayoutGrid5, {
        columns: 8,
        space: "three"
    }, rangeIndicator && /* @__PURE__ */ React22.createElement(UitkLayoutGridItem5, {
        colSpan: 2
    }, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(UitkCard3, {
        padded: true,
        backgroundTheme: "secondary"
    }, /* @__PURE__ */ React22.createElement("div", null, rangeIndicator)))), /* @__PURE__ */ React22.createElement(UitkLayoutGridItem5, {
        colSpan: rangeIndicator ? 6 : 8
    }, /* @__PURE__ */ React22.createElement("div", null, graph))))))));
};
DestinationInsightsMonthlyDetails.fragment = _Fragment3;
DestinationInsightsMonthlyDetails.displayName = "DestinationInsightsMonthlyDetails";
// src/components/months-forecast-price-tab/destination-monthly-price-tabs.tsx
import React24 from "react";
import { gql as gql26 } from "@apollo/client";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5 } from "uitk-react-text";
// src/components/months-forecast-price-tab/months-forecasts-price.tsx
import React23 from "react";
import { gql as gql25 } from "@apollo/client";
import { LayoutGridColumnHeadingInteractive, SetGridItem as SetGridItem2, YAxisLine as YAxisLine2 } from "@egds/react-acquisition-marketing-growth-landing";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { Repeat as Repeat2, UitkLayoutGrid as UitkLayoutGrid6, UitkLayoutGridItem as UitkLayoutGridItem6 } from "uitk-react-layout-grid";
import { UitkScrollable as UitkScrollable2 } from "uitk-react-scrollable";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkText as UitkText11 } from "uitk-react-text";
var __Fragment5 = gql25(_templateObject24(), DestinationInsightsMonthlyDataFragment);
var MonthsForecastsPrice = function(param) {
    var data = param.data, _param_priceTabMinWidth = param.priceTabMinWidth, priceTabMinWidth = _param_priceTabMinWidth === void 0 ? 707 : _param_priceTabMinWidth, _param_isInteractive = param.isInteractive, isInteractive = _param_isInteractive === void 0 ? false : _param_isInteractive;
    var clickTracker = useClickTracker8();
    var _React23_useState = _sliced_to_array(React23.useState(0), 2), selectedTabIndex = _React23_useState[0], setSelectedTabIndexState = _React23_useState[1];
    var totalRows = 500;
    var additionalRows = 80;
    var verticalLineStartingPoint = 60;
    var currentMonth = data.monthlyData.findIndex(function(month) {
        return month.selected;
    });
    var monthsTabs = data.monthlyData.slice(currentMonth, data.monthlyData.length).concat(data.monthlyData.slice(0, currentMonth));
    var maxPrice = Math.max.apply(null, monthsTabs.map(function(tab) {
        return tab.averagePrice.priceAsNumber;
    }));
    var handleTabChange = React23.useCallback(function(tabIndex) {
        if (selectedTabIndex !== tabIndex) {
            setSelectedTabIndexState(tabIndex);
            var interactionItem = monthsTabs[tabIndex].click;
            clickTracker(interactionItem.referrerId, interactionItem.linkName);
        }
    }, [
        selectedTabIndex
    ]);
    var setGridRow = function(price) {
        return totalRows - Math.round(price * totalRows / maxPrice);
    };
    var getVerticalLine = function(tabIndex, row, startingIndex) {
        var lines = [];
        for(var index = startingIndex !== null && startingIndex !== void 0 ? startingIndex : 0; index < row; index += 1){
            lines.push(/* @__PURE__ */ React23.createElement(UitkLayoutGridItem6, {
                rowStart: index,
                colStart: tabIndex + 1
            }, /* @__PURE__ */ React23.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React23.createElement("div", null, /* @__PURE__ */ React23.createElement(YAxisLine2, null)))));
        }
        return lines;
    };
    return /* @__PURE__ */ React23.createElement(UitkScrollable2, {
        direction: "horizontal",
        tag: "section"
    }, /* @__PURE__ */ React23.createElement("div", {
        style: {
            width: "100%"
        }
    }, /* @__PURE__ */ React23.createElement(UitkLayoutFlex7, {
        direction: "column",
        style: {
            width: "auto",
            minWidth: "".concat(priceTabMinWidth, "px")
        }
    }, /* @__PURE__ */ React23.createElement(UitkSpacing11, {
        margin: {
            blockstart: "three"
        },
        padding: {
            blockstart: "four",
            inline: "three"
        },
        style: {
            height: "250px"
        }
    }, /* @__PURE__ */ React23.createElement("div", null, /* @__PURE__ */ React23.createElement(UitkLayoutGrid6, {
        columns: [
            Repeat2(monthsTabs.length, "1fr")
        ],
        rows: totalRows + additionalRows,
        blockSize: "full_size"
    }, monthsTabs.map(function(monthTab, tabIndex) {
        return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement(UitkLayoutGridItem6, {
            key: tabIndex,
            colStart: tabIndex + 1,
            rowStart: 0,
            rowSpan: "all",
            rowEnd: 1,
            alignSelf: "center",
            justifySelf: "center",
            style: {
                width: "100%"
            }
        }, /* @__PURE__ */ React23.createElement("div", {
            style: {
                alignContent: "center",
                justifyContent: "center"
            }
        }, /* @__PURE__ */ React23.createElement(LayoutGridColumnHeadingInteractive, {
            onClick: handleTabChange,
            index: tabIndex,
            label: monthTab.label,
            selected: tabIndex === selectedTabIndex,
            isInteractive: isInteractive
        }))), isInteractive && tabIndex === selectedTabIndex && getVerticalLine(tabIndex, setGridRow(monthTab.averagePrice.priceAsNumber) + additionalRows, verticalLineStartingPoint), /* @__PURE__ */ React23.createElement(UitkLayoutGridItem6, {
            key: tabIndex,
            colStart: tabIndex + 1,
            rowStart: setGridRow(monthTab.averagePrice.priceAsNumber) + additionalRows,
            rowSpan: "all",
            rowEnd: totalRows + additionalRows
        }, /* @__PURE__ */ React23.createElement("div", null, /* @__PURE__ */ React23.createElement(UitkSpacing11, {
            margin: {
                inline: "one",
                blockend: "two"
            }
        }, /* @__PURE__ */ React23.createElement(UitkText11, {
            align: "center",
            whiteSpace: "nowrap",
            weight: isInteractive && monthsTabs.indexOf(monthTab) === selectedTabIndex ? "bold" : "regular"
        }, monthTab.averagePrice.priceAsText)), /* @__PURE__ */ React23.createElement(UitkLayoutGrid6, {
            onClick: function() {
                return handleTabChange(tabIndex);
            },
            blockSize: "full_size",
            rows: monthTab.averagePrice.priceAsNumber - 1
        }, /* @__PURE__ */ React23.createElement(UitkLayoutGridItem6, {
            rowSpan: "all",
            rowEnd: monthTab.averagePrice.priceAsNumber,
            alignSelf: "center",
            justifySelf: "center",
            style: {
                cursor: isInteractive ? "pointer" : ""
            }
        }, /* @__PURE__ */ React23.createElement(UitkSpacing11, {
            margin: {
                blockstart: "one",
                blockend: "one"
            }
        }, /* @__PURE__ */ React23.createElement(UitkLayoutFlex7, {
            direction: "column",
            justifyContent: "center",
            alignContent: "center",
            blockSize: "full_size"
        }, /* @__PURE__ */ React23.createElement(UitkLayoutFlexItem7, {
            alignSelf: "center"
        }, /* @__PURE__ */ React23.createElement(SetGridItem2, {
            selected: isInteractive && monthsTabs.indexOf(monthTab) === selectedTabIndex,
            accessibility: monthTab.accessibility || void 0,
            borderRadiusTop: true
        })))))))));
    })))))));
};
MonthsForecastsPrice.displayName = "MonthsForecastsPrice";
MonthsForecastsPrice.fragment = __Fragment5;
// src/components/months-forecast-price-tab/destination-monthly-price-tabs.tsx
var _Fragment4 = gql26(_templateObject25(), DestinationInsightsTooltip.fragment, MonthsForecastsPrice.fragment);
var DestinationMonthlyPriceTabs = function(param) {
    var data = param.data, _param_priceTabHeight = param.priceTabHeight, priceTabHeight = _param_priceTabHeight === void 0 ? "305px" : _param_priceTabHeight, priceTabMinWidth = param.priceTabMinWidth, _param_isInteractive = param.isInteractive, isInteractive = _param_isInteractive === void 0 ? false : _param_isInteractive;
    var graphRef = React24.useRef(null);
    var title = data.title, subtitle = data.subtitle, tooltip = data.tooltip;
    return /* @__PURE__ */ React24.createElement(UitkSpacing12, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React24.createElement("div", null, /* @__PURE__ */ React24.createElement(UitkSpacing12, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React24.createElement("div", null, /* @__PURE__ */ React24.createElement(UitkHeading5, {
        size: 7,
        tag: "h2"
    }, title), /* @__PURE__ */ React24.createElement(DestinationInsightsTooltip, {
        data: tooltip,
        triggerText: subtitle,
        closeTooltipOnClick: true,
        externalDivRef: graphRef,
        destinationInsightsTooltipMargin: {
            inlinestart: "unset"
        },
        textSize: 100
    }))), /* @__PURE__ */ React24.createElement(UitkSpacing12, {
        padding: {
            small: {
                blockstart: "four"
            }
        },
        style: {
            height: priceTabHeight
        }
    }, /* @__PURE__ */ React24.createElement("div", null, /* @__PURE__ */ React24.createElement(MonthsForecastsPrice, {
        data: data,
        priceTabMinWidth: priceTabMinWidth,
        isInteractive: isInteractive
    })))));
};
DestinationMonthlyPriceTabs.fragment = _Fragment4;
DestinationMonthlyPriceTabs.displayName = "DestinationMonthlyPriceTabs";
// src/components/destination-best-time-to-go-information/private/destination-best-time-to-go-information-tab-information.tsx
var __fragment2 = gql27(_templateObject26(), DestinationInsightsMonthlyDetails.fragment, DestinationMonthlyHistoricalForecast.fragment);
var DestinationBestTimeToGoInformationTabInformation = function(param) {
    var data = param.data, priceTabOptions = param.priceTabOptions, weatherTabCustomHeight = param.weatherTabCustomHeight, _param_showTabs = param.showTabs, showTabs = _param_showTabs === void 0 ? false : _param_showTabs;
    var _ref = priceTabOptions || {}, customId = _ref.customId, customYFontSize = _ref.customYFontSize, customXFontSize = _ref.customXFontSize, customTickTextFontSize = _ref.customTickTextFontSize, customGraphStyle = _ref.customGraphStyle, graphCustomWidth = _ref.graphCustomWidth, svgCustomWidth = _ref.svgCustomWidth, graphCustomHeight = _ref.graphCustomHeight, customAccessibilityRadius = _ref.customAccessibilityRadius, priceTabHeight = _ref.priceTabHeight, priceTabMinWidth = _ref.priceTabMinWidth;
    var viewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var isSmallViewport = defaultViewSizes.SMALL === viewSize;
    var isMobileSvgCustomWidth = "150vw";
    var isMobileGraphCustomWidth = 700;
    var fontSize = 12;
    var textSize = 100;
    if (!isSmallViewport) {
        if (viewSize >= defaultViewSizes.LARGE) {
            isMobileSvgCustomWidth = "90vw";
            isMobileGraphCustomWidth = 1e3;
            fontSize = 10;
            textSize = 200;
        } else {
            isMobileSvgCustomWidth = "100vw";
            isMobileGraphCustomWidth = 700;
            fontSize = 11;
            textSize = 200;
        }
    }
    switch(data.__typename){
        case "DestinationInsightsMonthlyDetails":
            return /* @__PURE__ */ React25.createElement(UitkSpacing13, {
                padding: {
                    blockstart: "one",
                    inlinestart: "one"
                }
            }, /* @__PURE__ */ React25.createElement("div", null, showTabs ? /* @__PURE__ */ React25.createElement(DestinationMonthlyPriceTabs, {
                data: data,
                priceTabHeight: priceTabHeight,
                priceTabMinWidth: priceTabMinWidth,
                isInteractive: priceTabOptions === null || priceTabOptions === void 0 ? void 0 : priceTabOptions.isInteractive
            }) : /* @__PURE__ */ React25.createElement(DestinationInsightsMonthlyDetails, {
                data: data,
                customId: customId !== null && customId !== void 0 ? customId : "destination-best-time-to-go-tab-",
                isMobileContainerCustomWidth: "100%",
                isMobileSvgCustomWidth: svgCustomWidth !== null && svgCustomWidth !== void 0 ? svgCustomWidth : isMobileSvgCustomWidth,
                forceMobileView: true,
                isMobileGraphCustomWidth: graphCustomWidth !== null && graphCustomWidth !== void 0 ? graphCustomWidth : isMobileGraphCustomWidth,
                isMobileGraphCustomHeight: graphCustomHeight !== null && graphCustomHeight !== void 0 ? graphCustomHeight : 200,
                removeMobileGraphSpacing: true,
                isMobileCurrentMonthInitialIndex: true,
                mobileCustomVerticalTicks: 7,
                xTickPadding: 18,
                yTickPadding: 30,
                customGraphStyle: customGraphStyle !== null && customGraphStyle !== void 0 ? customGraphStyle : {
                    margin: "-40px -30px -60px -15px",
                    overflow: "hidden"
                },
                addYMinMaxLimit: true,
                customYFontSize: "".concat(customYFontSize !== null && customYFontSize !== void 0 ? customYFontSize : fontSize, "px"),
                customXFontSize: "".concat(customXFontSize !== null && customXFontSize !== void 0 ? customXFontSize : fontSize, "px"),
                customTickTextFontSize: customTickTextFontSize !== null && customTickTextFontSize !== void 0 ? customTickTextFontSize : fontSize,
                destinationInsightsTooltipMargin: {
                    inlinestart: "unset"
                },
                closeTooltipOnClick: true,
                textSize: textSize,
                headingSize: 7,
                customAccessibilityRadius: customAccessibilityRadius !== null && customAccessibilityRadius !== void 0 ? customAccessibilityRadius : 30
            })));
        case "DestinationMonthlyHistoricalForecast":
            return /* @__PURE__ */ React25.createElement(DestinationMonthlyHistoricalForecast, {
                data: data,
                customHeight: weatherTabCustomHeight !== null && weatherTabCustomHeight !== void 0 ? weatherTabCustomHeight : 220,
                isScrollable: true
            });
        default:
            return null;
    }
};
DestinationBestTimeToGoInformationTabInformation.fragment = __fragment2;
DestinationBestTimeToGoInformationTabInformation.displayName = "DestinationBestTimeToGoInformationTabInformation";
// src/components/destination-best-time-to-go-information/private/destination-best-time-to-go-information-tabs.tsx
var __fragment3 = gql28(_templateObject27(), DestinationBestTimeToGoInformationTabInformation.fragment);
var DestinationBestTimeToGoInformationTabs = function(param) {
    var data = param.data, priceTabOptions = param.priceTabOptions, weatherTabCustomHeight = param.weatherTabCustomHeight, showTabs = param.showTabs, backgroundThemeOverride = param.backgroundThemeOverride;
    var tabs = data.tabs;
    var _React26_useState = _sliced_to_array(React26.useState(0), 2), selectedTabIndex = _React26_useState[0], setSelectedTabIndex = _React26_useState[1];
    var handleTabChange = function(tabIndex) {
        setSelectedTabIndex(tabIndex);
    };
    var getChild = function(childData) {
        return backgroundThemeOverride === "secondary" ? /* @__PURE__ */ React26.createElement(UitkCard4, {
            style: {
                marginTop: "-12px",
                paddingTop: "12px"
            }
        }, /* @__PURE__ */ React26.createElement("div", null, /* @__PURE__ */ React26.createElement(DestinationBestTimeToGoInformationTabInformation, {
            data: childData,
            priceTabOptions: priceTabOptions,
            weatherTabCustomHeight: weatherTabCustomHeight,
            showTabs: showTabs
        }))) : /* @__PURE__ */ React26.createElement(DestinationBestTimeToGoInformationTabInformation, {
            data: childData,
            priceTabOptions: priceTabOptions,
            weatherTabCustomHeight: weatherTabCustomHeight,
            showTabs: showTabs
        });
    };
    return /* @__PURE__ */ React26.createElement(UitkTabs2, {
        backgroundColor: backgroundThemeOverride === "secondary" ? UitkTabsBackGroundColorType.SECONDARY : UitkTabsBackGroundColorType.PRIMARY,
        tabsType: UitkTabsType2.NATURAL,
        centerAlign: true,
        role: "tablist",
        withBorder: backgroundThemeOverride !== "secondary",
        onTabSelect: handleTabChange,
        selectedTab: selectedTabIndex,
        className: "uitk-card-roundcorner-top-left uitk-card-roundcorner-top-right"
    }, tabs.map(function(tab, tabIndex) /* @__PURE__ */ {
        var _tab_title, _tab_impression, _tab_impression1, _tab_impression2;
        var _tab_title_text, _tab_impression_referrerId, _tab_impression_linkName;
        return React26.createElement(UitkTab2, {
            key: "tab".concat(tabIndex),
            name: (_tab_title_text = (_tab_title = tab.title) === null || _tab_title === void 0 ? void 0 : _tab_title.text) !== null && _tab_title_text !== void 0 ? _tab_title_text : "",
            targetURI: "tab".concat(tabIndex)
        }, ((_tab_impression = tab.impression) === null || _tab_impression === void 0 ? void 0 : _tab_impression.referrerId) ? /* @__PURE__ */ React26.createElement(IntersectionTracker, {
            trackOnce: false,
            referrerId: (_tab_impression_referrerId = (_tab_impression1 = tab.impression) === null || _tab_impression1 === void 0 ? void 0 : _tab_impression1.referrerId) !== null && _tab_impression_referrerId !== void 0 ? _tab_impression_referrerId : "",
            linkName: (_tab_impression_linkName = (_tab_impression2 = tab.impression) === null || _tab_impression2 === void 0 ? void 0 : _tab_impression2.linkName) !== null && _tab_impression_linkName !== void 0 ? _tab_impression_linkName : ""
        }, getChild(tab.information)) : getChild(tab.information));
    }));
};
DestinationBestTimeToGoInformationTabs.fragment = __fragment3;
DestinationBestTimeToGoInformationTabs.displayName = "DestinationBestTimeToGoInformationTabs";
// src/components/destination-best-time-to-go-information/destination-best-time-to-go-information.tsx
var __Query = gql29(_templateObject28(), DestinationBestTimeToGoInformationExpando.fragment, DestinationBestTimeToGoInformationTabs.fragment, EGDSButton.fragment);
var DestinationBestTimeToGoInformation = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_showSkeleton = props.showSkeleton, showSkeleton = _props_showSkeleton === void 0 ? false : _props_showSkeleton, weatherTabCustomHeight = props.weatherTabCustomHeight, priceTabOptions = props.priceTabOptions, _props_showTabs = props.showTabs, showTabs = _props_showTabs === void 0 ? false : _props_showTabs, _props_isHidden = props.isHidden, isHidden = _props_isHidden === void 0 ? false : _props_isHidden, backgroundThemeOverride = props.backgroundThemeOverride;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading && showSkeleton) {
        return /* @__PURE__ */ React27.createElement(DestinationBestTimeToGoInformationPlaceholder, null);
    }
    if (loading && !showSkeleton || error || !(data === null || data === void 0 ? void 0 : data.destinationBestTimeToGoInformation)) {
        return null;
    }
    var destinationBestTimeToGoInformation = data.destinationBestTimeToGoInformation;
    var tabs = destinationBestTimeToGoInformation.tabs, expando = destinationBestTimeToGoInformation.expando, viewAllPropertiesButton = destinationBestTimeToGoInformation.viewAllPropertiesButton;
    if (!tabs.length) {
        return null;
    }
    var bestTimeToGo = /* @__PURE__ */ React27.createElement("div", {
        className: isHidden ? "is-visually-hidden" : ""
    }, /* @__PURE__ */ React27.createElement(DestinationBestTimeToGoInformationExpando, {
        data: expando,
        backgroundThemeOverride: backgroundThemeOverride
    }, /* @__PURE__ */ React27.createElement(UitkSpacing14, {
        margin: {
            inline: "four"
        }
    }, /* @__PURE__ */ React27.createElement("div", null, /* @__PURE__ */ React27.createElement(ViewRow, {
        canvasTheme: backgroundThemeOverride === "secondary" ? "none" : "primary",
        layout: "fullwidth",
        className: "uitk-card-roundcorner-all",
        paddedViewRow: false
    }, /* @__PURE__ */ React27.createElement(DestinationBestTimeToGoInformationTabs, {
        data: destinationBestTimeToGoInformation,
        priceTabOptions: priceTabOptions,
        weatherTabCustomHeight: weatherTabCustomHeight,
        showTabs: showTabs,
        backgroundThemeOverride: backgroundThemeOverride
    })), viewAllPropertiesButton && /* @__PURE__ */ React27.createElement(UitkLayoutFlex8, {
        justifyContent: "center",
        alignContent: "center"
    }, /* @__PURE__ */ React27.createElement(UitkSpacing14, {
        margin: {
            blockstart: "four",
            blockend: "one"
        }
    }, /* @__PURE__ */ React27.createElement(EGDSButton, {
        data: viewAllPropertiesButton,
        isFullWidth: false
    })))))));
    var _ref = destinationBestTimeToGoInformation.impression || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    return referrerId ? /* @__PURE__ */ React27.createElement(IntersectionTracker2, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName !== null && linkName !== void 0 ? linkName : ""
    }, bestTimeToGo) : bestTimeToGo;
};
DestinationBestTimeToGoInformation.displayName = "sharedui-DestinationBestTimeToGoInformation";
// src/components/destination-guide-heading/destination-guide-heading.tsx
import React41 from "react";
import { gql as gql43, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7, UitkParagraph as UitkParagraph2, UitkText as UitkText15 } from "uitk-react-text";
// src/components/destination-gallery/destination-gallery.tsx
import React39 from "react";
import { gql as gql41 } from "@apollo/client";
// src/components/destination-image-gallery-item/destination-image-gallery-item.tsx
import React30 from "react";
import { gql as gql32 } from "@apollo/client";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType3 } from "uitk-react-images";
// src/components/destination-recommendation-card-attribution/destination-recommendation-card-attribution.tsx
import React28 from "react";
import { gql as gql30 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex9 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid7, UitkLayoutGridItem as UitkLayoutGridItem7 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkLinkSizes as UitkLinkSizes2 } from "uitk-react-link";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
import { UitkText as UitkText12 } from "uitk-react-text";
var __Fragment6 = gql30(_templateObject29(), EGDSStandardLink.fragment);
var attributionTextProps = {
    theme: "inverse",
    size: 100,
    overflow: "truncate"
};
var DestinationRecommendationCardAttribution = function(param) {
    var data = param.data;
    var text = data.text, contents = data.contents;
    return /* @__PURE__ */ React28.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            left: "zero",
            right: "zero",
            bottom: "zero"
        }
    }, /* @__PURE__ */ React28.createElement(UitkLayoutGrid7, {
        columns: [
            "1fr",
            "min-content"
        ],
        space: "one",
        alignItems: "center",
        justifyItems: "end"
    }, /* @__PURE__ */ React28.createElement(UitkLayoutGridItem7, null, /* @__PURE__ */ React28.createElement(UitkLayoutPosition2, {
        type: "relative",
        position: {
            zindex: "layer3"
        }
    }, /* @__PURE__ */ React28.createElement(UitkSpacing15, {
        padding: {
            block: "one"
        }
    }, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(UitkLayoutFlex9, {
        justifyContent: "end",
        alignItems: "center",
        space: "one",
        wrap: "wrap"
    }, contents.map(function(content, index) {
        switch(content === null || content === void 0 ? void 0 : content.__typename){
            case "EGDSStandardLink":
                return /* @__PURE__ */ React28.createElement(UitkLayoutFlex9, {
                    key: index,
                    justifyContent: "end",
                    alignItems: "center",
                    space: "one"
                }, /* @__PURE__ */ React28.createElement(EGDSStandardLink, {
                    data: content,
                    textProps: attributionTextProps,
                    linkSize: UitkLinkSizes2.get("small"),
                    showIcon: true,
                    theme: "inverse"
                }));
            default:
                return /* @__PURE__ */ React28.createElement(UitkText12, _object_spread({
                    key: index
                }, attributionTextProps), content.text);
        }
    }), /* @__PURE__ */ React28.createElement(UitkText12, {
        className: "is-visually-hidden"
    }, text)))))), /* @__PURE__ */ React28.createElement(UitkSpacing15, {
        padding: {
            blockstart: "unset"
        }
    }, /* @__PURE__ */ React28.createElement(UitkScrim, {
        type: UitkScrimType.OVERLAY
    }))));
};
DestinationRecommendationCardAttribution.fragment = __Fragment6;
DestinationRecommendationCardAttribution.displayName = "DestinationRecommendationCardAttribution";
// src/components/image/image.tsx
import React29 from "react";
import { gql as gql31 } from "@apollo/client";
import { UitkFigure, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "uitk-react-images";
// src/components/image/__private/image-aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
var _obj5;
var UitkImageAspectRatioMap = Object.freeze((_obj5 = {}, _define_property(_obj5, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _define_property(_obj5, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _define_property(_obj5, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _define_property(_obj5, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _define_property(_obj5, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _define_property(_obj5, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _define_property(_obj5, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _obj5));
// src/components/image/image.tsx
var fragment11 = gql31(_templateObject30());
var Image = function(param) {
    var data = param.data, ratio = param.ratio, attribution = param.attribution;
    var description = data.description, url = data.url, aspectRatio = data.aspectRatio;
    var _ref;
    var imageRatio = (_ref = ratio !== null && ratio !== void 0 ? ratio : aspectRatio) !== null && _ref !== void 0 ? _ref : false;
    var _ref1;
    return /* @__PURE__ */ React29.createElement(UitkFigure, _object_spread({
        roundcorner: true
    }, imageRatio ? {
        ratio: (_ref1 = ratio !== null && ratio !== void 0 ? ratio : aspectRatio && UitkImageAspectRatioMap[aspectRatio]) !== null && _ref1 !== void 0 ? _ref1 : UitkFigureAspectRatioType2.R3_4
    } : {}), /* @__PURE__ */ React29.createElement(UitkImage, {
        placeholderImage: true,
        alt: description,
        src: url,
        lazyLoading: "lazy"
    }), attribution && /* @__PURE__ */ React29.createElement(DestinationRecommendationCardAttribution, {
        data: attribution
    }));
};
Image.fragment = fragment11;
Image.displayName = "Image";
// src/components/destination-image-gallery-item/destination-image-gallery-item.tsx
var _Fragment5 = gql32(_templateObject31(), ClientSideAnalyticsFragment, DestinationRecommendationCardAttribution.fragment, Image.fragment);
var DestinationImageGalleryItem = function(param) {
    var data = param.data;
    var image = data.image, attribution = data.attribution;
    return /* @__PURE__ */ React30.createElement(Image, {
        data: image,
        ratio: UitkFigureAspectRatioType3.R16_9,
        attribution: attribution !== null && attribution !== void 0 ? attribution : void 0
    });
};
DestinationImageGalleryItem.fragment = _Fragment5;
DestinationImageGalleryItem.displayName = "DestinationImageGalleryItem";
// src/components/egds-carousel/egds-carousel.tsx
import React38 from "react";
import { gql as gql40 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { UitkCarousel as UitkCarousel2 } from "uitk-react-carousel";
// src/components/destination-recommendation-card/destination-recommendation-card.tsx
import React37 from "react";
import { gql as gql39 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-text.tsx
import React33 from "react";
import { gql as gql35 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React31 from "react";
import { gql as gql33 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var fragment12 = gql33(_templateObject32());
var EGDSParagraph = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React31.createElement(UitkParagraph, null, data.text);
};
EGDSParagraph.fragment = fragment12;
EGDSParagraph.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React32 from "react";
import { gql as gql34 } from "@apollo/client";
import { UitkText as UitkText13 } from "uitk-react-text";
var fragment13 = gql34(_templateObject33());
var EGDSPlainText2 = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React32.createElement(UitkText13, null, data.text);
};
EGDSPlainText2.fragment = fragment13;
EGDSPlainText2.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment14 = gql35(_templateObject34(), EGDSParagraph.fragment, EGDSPlainText2.fragment);
var EGDSText = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "EGDSParagraph":
            return /* @__PURE__ */ React33.createElement(EGDSParagraph, {
                data: data
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React33.createElement(EGDSPlainText2, {
                data: data
            });
        default:
            return null;
    }
};
EGDSText.fragment = fragment14;
EGDSText.displayName = "EGDSText";
// src/components/destination-recommendation-card/destination-recommendation-card.tsx
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6 } from "uitk-react-text";
// src/components/destination-recommendation-card-media/destination-recommendation-card-media.tsx
import React35 from "react";
import { gql as gql37 } from "@apollo/client";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
// src/components/destination-recommendation-card-image/destination-recommendation-card-image.tsx
import React34 from "react";
import { gql as gql36 } from "@apollo/client";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType4 } from "uitk-react-images";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
import { UitkText as UitkText14 } from "uitk-react-text";
var _Fragment6 = gql36(_templateObject35(), DestinationRecommendationCardAttribution.fragment, Image.fragment);
var DestinationRecommendationCardImage = function(param) {
    var data = param.data;
    var image = data.image, attribution = data.attribution;
    return /* @__PURE__ */ React34.createElement(UitkLayoutPosition3, {
        type: "relative"
    }, image && /* @__PURE__ */ React34.createElement(Image, {
        attribution: attribution !== null && attribution !== void 0 ? attribution : void 0,
        data: image,
        ratio: UitkFigureAspectRatioType4.R3_4
    }), /* @__PURE__ */ React34.createElement(UitkLayoutPosition3, {
        type: "absolute",
        position: {
            bottom: attribution ? "six" : "two",
            left: "two",
            zindex: "layer1"
        },
        display: "block"
    }, /* @__PURE__ */ React34.createElement(UitkSpacing16, {
        padding: {
            inline: "one"
        }
    }, /* @__PURE__ */ React34.createElement(UitkText14, {
        theme: "inverse"
    }, image === null || image === void 0 ? void 0 : image.description))));
};
DestinationRecommendationCardImage.fragment = _Fragment6;
DestinationRecommendationCardImage.displayName = "DestinationRecommendationCardImage";
// src/components/destination-recommendation-card-media/destination-recommendation-card-media.tsx
var _Fragment7 = gql37(_templateObject36(), Image.fragment, DestinationRecommendationCardImage.fragment, DestinationRecommendationCardAttribution.fragment);
var DestinationRecommendationCardMedia = function(props) {
    var data = props.data, carousel = props.carousel, ratio = props.ratio;
    var __typename = data.__typename;
    var _data_attribution;
    return /* @__PURE__ */ React35.createElement(React35.Fragment, null, __typename === "DestinationRecommendationCardImages" ? /* @__PURE__ */ React35.createElement(React35.Fragment, null, carousel && /* @__PURE__ */ React35.createElement(UitkSpacing17, {
        padding: {
            inlinestart: "six"
        }
    }, /* @__PURE__ */ React35.createElement(EGDSCarousel, {
        stretchToFill: true,
        customItemVisible: {
            sm: 2,
            md: 2,
            lg: 2,
            xl: 2
        },
        data: carousel,
        carouselContent: _to_consumable_array(data.images || []),
        peek: true
    }))) : data.image && /* @__PURE__ */ React35.createElement(Image, {
        data: data.image,
        attribution: (_data_attribution = data.attribution) !== null && _data_attribution !== void 0 ? _data_attribution : void 0,
        ratio: ratio
    }));
};
DestinationRecommendationCardMedia.fragment = _Fragment7;
DestinationRecommendationCardMedia.displayName = "DestinationRecommendationCardMedia";
// src/components/egds-standard-badge/egds-standard-badge.tsx
import React36 from "react";
import { gql as gql38 } from "@apollo/client";
import { UitkBadgeStandard as UitkBadgeStandard2, UitkBadgeStandardThemes as UitkBadgeStandardThemes2 } from "uitk-react-badge";
var fragment15 = gql38(_templateObject37(), UiGraphic.fragment);
var EGDSStandardBadge = function(param) {
    var className = param.className, size = param.size, data = param.data;
    var text = data.text, theme = data.theme, accessibility = data.accessibility;
    var themeProps = theme ? UitkBadgeStandardThemes2[theme] : void 0;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React36.createElement(UitkBadgeStandard2, {
        className: className,
        size: size,
        theme: themeProps,
        text: text,
        a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : ""
    });
};
EGDSStandardBadge.fragment = fragment15;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// src/components/destination-recommendation-card/destination-recommendation-card.tsx
var fragment16 = gql39(_templateObject38(), EGDSParagraph.fragment, EGDSStandardBadge.fragment, DestinationRecommendationCardMedia.fragment);
var DestinationRecommendationCard = function(props) {
    var data = props.data, carousel = props.carousel;
    var heading = data.heading, media = data.media, affinities = data.affinities, details = data.details;
    return /* @__PURE__ */ React37.createElement(React37.Fragment, null, /* @__PURE__ */ React37.createElement(DestinationRecommendationCardMedia, {
        data: media,
        carousel: carousel
    }), (heading === null || heading === void 0 ? void 0 : heading.title) && /* @__PURE__ */ React37.createElement(UitkSpacing18, {
        margin: {
            blockstart: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React37.createElement(UitkHeading6, {
        size: 6
    }, heading.title)), (affinities === null || affinities === void 0 ? void 0 : affinities.badges) && /* @__PURE__ */ React37.createElement(UitkSpacing18, {
        margin: {
            inline: "six"
        }
    }, /* @__PURE__ */ React37.createElement("div", null, affinities === null || affinities === void 0 ? void 0 : affinities.badges.map(function(badge, index) {
        return /* @__PURE__ */ React37.createElement(UitkSpacing18, {
            key: index,
            margin: {
                inlineend: "two",
                blockstart: "four"
            }
        }, /* @__PURE__ */ React37.createElement(EGDSStandardBadge, {
            data: badge
        }));
    }))), details.map(function(detail, detailsIndex) {
        return /* @__PURE__ */ React37.createElement(React37.Fragment, {
            key: "detail".concat(detailsIndex)
        }, detail.heading && /* @__PURE__ */ React37.createElement(UitkSpacing18, {
            padding: {
                blockstart: "four",
                inline: carousel ? "six" : "unset"
            }
        }, /* @__PURE__ */ React37.createElement(UitkHeading6, {
            size: 5
        }, detail.heading.title)), detail.content && detail.content.__typename === "EGDSParagraph" && /* @__PURE__ */ React37.createElement(UitkSpacing18, {
            margin: {
                block: "two",
                inline: carousel ? "six" : "unset"
            }
        }, /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(EGDSParagraph, {
            data: detail.content
        }))));
    }));
};
DestinationRecommendationCard.fragment = fragment16;
DestinationRecommendationCard.displayName = "DestinationRecommendationCard";
// src/components/egds-carousel/egds-carousel.tsx
var __Fragment7 = gql40(_templateObject39(), EGDSButton.fragment);
var EGDSCarousel = function(param) {
    var carouselName = param.carouselName, data = param.data, className = param.className, peek = param.peek, itemsVisible = param.itemsVisible, currentIndex = param.currentIndex, stretchToFill = param.stretchToFill, fullSheetVisible = param.fullSheetVisible, carouselContent = param.carouselContent, customItemVisible = param.customItemVisible, itemsMaxHeight = param.itemsMaxHeight;
    var _data_nextButton, _data_previousButton, _data_nextButton1, _data_previousButton1;
    var defaultItemsVisible = {
        sm: 1,
        md: 1,
        lg: 1,
        xl: 1
    };
    var trackClick = useClickTracker9();
    var nextAnalytics = (_data_nextButton = data.nextButton) === null || _data_nextButton === void 0 ? void 0 : _data_nextButton.analytics;
    var prevAnalytics = (_data_previousButton = data.previousButton) === null || _data_previousButton === void 0 ? void 0 : _data_previousButton.analytics;
    var onIndexChange = function() {
        if (nextAnalytics) {
            trackClick(nextAnalytics.referrerId, nextAnalytics.linkName);
        }
        if (prevAnalytics) {
            trackClick(prevAnalytics.referrerId, prevAnalytics.linkName);
        }
    };
    var CarouselContent = carouselContent === null || carouselContent === void 0 ? void 0 : carouselContent.map(function(item, index) {
        switch(item.__typename){
            case "DestinationImageGalleryItem":
                return /* @__PURE__ */ React38.createElement(DestinationImageGalleryItem, {
                    key: index,
                    data: item
                });
            case "DestinationRecommendationCardImage":
                return /* @__PURE__ */ React38.createElement(DestinationRecommendationCardImage, {
                    key: index,
                    data: item
                });
            case "DestinationRecommendationCard":
                return /* @__PURE__ */ React38.createElement(DestinationRecommendationCard, {
                    key: index,
                    data: item
                });
            default:
                return null;
        }
    });
    var buttonTextMemo = React38.useMemo(function() {
        var _data_nextButton, _data_previousButton;
        var _data_nextButton_accessibility, _data_previousButton_accessibility;
        return {
            nextButton: (_data_nextButton_accessibility = (_data_nextButton = data.nextButton) === null || _data_nextButton === void 0 ? void 0 : _data_nextButton.accessibility) !== null && _data_nextButton_accessibility !== void 0 ? _data_nextButton_accessibility : "",
            prevButton: (_data_previousButton_accessibility = (_data_previousButton = data.previousButton) === null || _data_previousButton === void 0 ? void 0 : _data_previousButton.accessibility) !== null && _data_previousButton_accessibility !== void 0 ? _data_previousButton_accessibility : ""
        };
    }, [
        data.nextButton,
        data.previousButton
    ]);
    if (!carouselContent) {
        return null;
    }
    var _data_nextButton_accessibility, _data_previousButton_accessibility, _ref;
    return /* @__PURE__ */ React38.createElement(UitkCarousel2, {
        navigationIconId: {
            next: ((_data_nextButton_accessibility = (_data_nextButton1 = data.nextButton) === null || _data_nextButton1 === void 0 ? void 0 : _data_nextButton1.accessibility) !== null && _data_nextButton_accessibility !== void 0 ? _data_nextButton_accessibility : "") + Math.random().toString(36).slice(2, 5),
            prev: ((_data_previousButton_accessibility = (_data_previousButton1 = data.previousButton) === null || _data_previousButton1 === void 0 ? void 0 : _data_previousButton1.accessibility) !== null && _data_previousButton_accessibility !== void 0 ? _data_previousButton_accessibility : "") + Math.random().toString(36).slice(2, 5)
        },
        fullSheetVisible: fullSheetVisible !== null && fullSheetVisible !== void 0 ? fullSheetVisible : false,
        className: className,
        carouselName: carouselName !== null && carouselName !== void 0 ? carouselName : void 0,
        buttonText: buttonTextMemo,
        itemsVisible: (_ref = customItemVisible !== null && customItemVisible !== void 0 ? customItemVisible : itemsVisible) !== null && _ref !== void 0 ? _ref : defaultItemsVisible,
        pageBy: 1,
        peek: peek !== null && peek !== void 0 ? peek : false,
        startIndex: currentIndex,
        onIndexChange: onIndexChange,
        stretchToFill: stretchToFill !== null && stretchToFill !== void 0 ? stretchToFill : false,
        itemsMaxHeight: itemsMaxHeight,
        pagingInset: true
    }, CarouselContent);
};
EGDSCarousel.displayName = "EGDSCarousel";
EGDSCarousel.fragment = __Fragment7;
// src/components/destination-gallery/destination-gallery.tsx
var _Fragment8 = gql41(_templateObject40(), EGDSCarousel.fragment, DestinationImageGalleryItem.fragment);
var DestinationGallery = function(param) {
    var data = param.data;
    var carousel = data.carousel, items = data.items;
    return /* @__PURE__ */ React39.createElement(EGDSCarousel, {
        data: carousel,
        carouselContent: _to_consumable_array(items)
    });
};
DestinationGallery.fragment = _Fragment8;
DestinationGallery.displayName = "DestinationGallery";
// src/components/egds-expando-peek/egds-expando-peek.tsx
import React40 from "react";
import { gql as gql42 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek } from "uitk-react-expando";
var fragment17 = gql42(_templateObject41());
var EGDSExpandoPeek = function(param) {
    var className = param.className, data = param.data, children = param.children;
    var expandAnalytics = data.expandAnalytics, collapseAnalytics = data.collapseAnalytics, expandedLabel = data.expandedLabel, collapsedLabel = data.collapsedLabel, items = data.items, lines = data.lines;
    var _React40_useState = _sliced_to_array(React40.useState(false), 2), isVisible = _React40_useState[0], setIsVisible = _React40_useState[1];
    var handleClick = React40.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible,
        setIsVisible
    ]);
    var clickTracker = useClickTracker10();
    var defaultShowedLines = 5;
    var defaultShowedItems = 5;
    var _expandAnalytics_referrerId, _expandAnalytics_linkName;
    var expandoExpandAnalytics = {
        id: (_expandAnalytics_referrerId = expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.referrerId) !== null && _expandAnalytics_referrerId !== void 0 ? _expandAnalytics_referrerId : "",
        description: (_expandAnalytics_linkName = expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.linkName) !== null && _expandAnalytics_linkName !== void 0 ? _expandAnalytics_linkName : "",
        callback: React40.useCallback(function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }, [
            clickTracker
        ])
    };
    var _collapseAnalytics_referrerId, _collapseAnalytics_linkName;
    var expandoCollapseAnalytics = {
        id: (_collapseAnalytics_referrerId = collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.referrerId) !== null && _collapseAnalytics_referrerId !== void 0 ? _collapseAnalytics_referrerId : "",
        description: (_collapseAnalytics_linkName = collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.linkName) !== null && _collapseAnalytics_linkName !== void 0 ? _collapseAnalytics_linkName : "",
        callback: React40.useCallback(function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }, [
            clickTracker
        ])
    };
    return /* @__PURE__ */ React40.createElement(UitkExpandoPeek, {
        isVisible: isVisible,
        items: items !== null && items !== void 0 ? items : defaultShowedItems,
        lines: lines !== null && lines !== void 0 ? lines : defaultShowedLines,
        expandLabel: collapsedLabel !== null && collapsedLabel !== void 0 ? collapsedLabel : "",
        collapseLabel: expandedLabel !== null && expandedLabel !== void 0 ? expandedLabel : "",
        handleClick: handleClick,
        className: className,
        analytics: isVisible ? expandoCollapseAnalytics : expandoExpandAnalytics
    }, children);
};
EGDSExpandoPeek.fragment = fragment17;
EGDSExpandoPeek.displayName = "EGDSExpandoPeek";
// src/components/destination-guide-heading/destination-guide-heading.tsx
var __Query2 = gql43(_templateObject42(), DestinationGallery.fragment, EGDSStandardBadge.fragment, EGDSExpandoPeek.fragment);
var DestinationGuideHeading = function(props) {
    var _destinationBadges_badges;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi2().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query2, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.destinationHeading)) {
        return null;
    }
    var destinationHeading = data.destinationHeading;
    var expandoPeek = destinationHeading.expandoPeek, gallery = destinationHeading.gallery, destinationBadges = destinationHeading.destinationBadges;
    var badges = destinationBadges === null || destinationBadges === void 0 ? void 0 : (_destinationBadges_badges = destinationBadges.badges) === null || _destinationBadges_badges === void 0 ? void 0 : _destinationBadges_badges.map(function(badge, index) {
        return /* @__PURE__ */ React41.createElement(UitkSpacing19, {
            key: index,
            margin: {
                inlineend: "two",
                blockstart: "four"
            }
        }, /* @__PURE__ */ React41.createElement(EGDSStandardBadge, {
            data: badge
        }));
    });
    return /* @__PURE__ */ React41.createElement(React41.Fragment, null, /* @__PURE__ */ React41.createElement(DestinationGallery, {
        data: gallery
    }), /* @__PURE__ */ React41.createElement(UitkSpacing19, {
        margin: {
            blockstart: "one"
        },
        padding: {
            blockstart: "four",
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React41.createElement("div", null, destinationHeading.subtitle && /* @__PURE__ */ React41.createElement(UitkText15, {
        weight: "bold",
        size: 200
    }, destinationHeading.subtitle), destinationHeading.title && /* @__PURE__ */ React41.createElement(UitkSpacing19, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React41.createElement(UitkHeading7, {
        size: 3
    }, destinationHeading.title)), badges, /* @__PURE__ */ React41.createElement(UitkSpacing19, {
        margin: {
            blockstart: "four"
        }
    }, expandoPeek ? /* @__PURE__ */ React41.createElement(EGDSExpandoPeek, {
        data: expandoPeek
    }, /* @__PURE__ */ React41.createElement(UitkParagraph2, null, destinationHeading.description)) : /* @__PURE__ */ React41.createElement(UitkParagraph2, null, destinationHeading.description)))));
};
DestinationGuideHeading.displayName = "sharedui-DestinationGuideHeading";
// src/components/destination-hero-media/destination-hero-media.tsx
import React45 from "react";
import { gql as gql46, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
// ../internal/src/components/media-image-attribution/media-image-attribution.tsx
import React42 from "react";
import { gql as gql44 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex10 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid8, UitkLayoutGridItem as UitkLayoutGridItem8 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition4 } from "uitk-react-layout-position";
import { UitkLinkSizes as UitkLinkSizes3 } from "uitk-react-link";
import { UitkScrim as UitkScrim2, UitkScrimType as UitkScrimType2 } from "uitk-react-scrim";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
import { UitkText as UitkText16 } from "uitk-react-text";
var __fragment4 = gql44(_templateObject43(), EGDSStandardLink.fragment);
var attributionTextProps2 = {
    theme: "inverse",
    size: 100,
    overflow: "truncate"
};
var MediaImageAttribution = function(param) {
    var data = param.data;
    var text = data.text, inlineContent = data.inlineContent;
    return /* @__PURE__ */ React42.createElement(UitkLayoutPosition4, {
        type: "absolute",
        position: {
            left: "zero",
            right: "zero",
            bottom: "zero"
        }
    }, /* @__PURE__ */ React42.createElement(UitkLayoutGrid8, {
        columns: [
            "1fr",
            "min-content"
        ],
        space: "one",
        alignItems: "center",
        justifyItems: "end"
    }, /* @__PURE__ */ React42.createElement(UitkLayoutGridItem8, null, /* @__PURE__ */ React42.createElement(UitkLayoutPosition4, {
        type: "relative",
        position: {
            zindex: "layer3"
        }
    }, /* @__PURE__ */ React42.createElement(UitkSpacing20, {
        padding: {
            block: "one"
        }
    }, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(UitkLayoutFlex10, {
        justifyContent: "end",
        alignItems: "center",
        space: "one",
        wrap: "wrap"
    }, (inlineContent === null || inlineContent === void 0 ? void 0 : inlineContent.length) ? inlineContent.map(function(content, index) {
        switch(content === null || content === void 0 ? void 0 : content.__typename){
            case "EGDSStandardLink":
                return /* @__PURE__ */ React42.createElement(UitkLayoutFlex10, {
                    key: index,
                    justifyContent: "end",
                    alignItems: "center",
                    space: "one"
                }, /* @__PURE__ */ React42.createElement(EGDSStandardLink, {
                    data: content,
                    textProps: attributionTextProps2,
                    linkSize: UitkLinkSizes3.get("small"),
                    theme: "inverse"
                }));
            case "EGDSPlainText":
                return /* @__PURE__ */ React42.createElement(UitkText16, _object_spread({
                    key: index
                }, attributionTextProps2), content.text);
            default:
                return null;
        }
    }) : /* @__PURE__ */ React42.createElement(UitkText16, _object_spread({}, attributionTextProps2), text), /* @__PURE__ */ React42.createElement(UitkText16, {
        className: "is-visually-hidden"
    }, text)))))), /* @__PURE__ */ React42.createElement(UitkSpacing20, {
        padding: {
            blockstart: "unset"
        }
    }, /* @__PURE__ */ React42.createElement(UitkScrim2, {
        type: UitkScrimType2.BOTTOM
    }))));
};
MediaImageAttribution.fragment = __fragment4;
MediaImageAttribution.displayName = "MediaImageAttribution";
// src/components/destination-hero-media/destination-hero-media.tsx
import { ViewLarge as ViewLarge2, ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard5 } from "uitk-react-cards";
import { UitkLayoutPosition as UitkLayoutPosition6 } from "uitk-react-layout-position";
import { UitkScrim as UitkScrim3, UitkScrimType as UitkScrimType3 } from "uitk-react-scrim";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8 } from "uitk-react-text";
// src/components/destination-hero-media/util-components/card-content.tsx
import React43 from "react";
import { UitkLayoutFlex as UitkLayoutFlex11, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid9, UitkLayoutGridItem as UitkLayoutGridItem9 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition5 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing21 } from "uitk-react-spacing";
var CardContent = function(param) {
    var description = param.description, header = param.header, _param_verticallyCenter = param.verticallyCenter, verticallyCenter = _param_verticallyCenter === void 0 ? false : _param_verticallyCenter, _param_textFullWidth = param.textFullWidth, textFullWidth = _param_textFullWidth === void 0 ? false : _param_textFullWidth;
    var layoutType = verticallyCenter ? "absolute" : "relative";
    var justifyContent = verticallyCenter ? "center" : "end";
    var topPosition = verticallyCenter ? "center" : "zero";
    var cols = verticallyCenter ? 3 : 1;
    var textCols = textFullWidth ? cols : 1;
    return /* @__PURE__ */ React43.createElement(UitkSpacing21, {
        padding: {
            inline: verticallyCenter ? "twelve" : "six"
        }
    }, /* @__PURE__ */ React43.createElement(UitkLayoutPosition5, {
        type: layoutType,
        position: {
            top: topPosition
        }
    }, /* @__PURE__ */ React43.createElement(UitkLayoutFlex11, {
        direction: "column",
        justifyContent: justifyContent
    }, /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React43.createElement(React43.Fragment, null, /* @__PURE__ */ React43.createElement(UitkLayoutGrid9, {
        columns: cols
    }, /* @__PURE__ */ React43.createElement(UitkLayoutGridItem9, {
        colSpan: textCols
    }, /* @__PURE__ */ React43.createElement("div", null, header))), description && /* @__PURE__ */ React43.createElement(UitkSpacing21, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React43.createElement(UitkLayoutGrid9, {
        columns: cols
    }, /* @__PURE__ */ React43.createElement(UitkLayoutGridItem9, {
        colSpan: textCols
    }, /* @__PURE__ */ React43.createElement("div", null, description)))))))));
};
// src/components/destination-hero-media/__private/destination-hero-image/destination-hero-image.tsx
import React44 from "react";
import { gql as gql45 } from "@apollo/client";
import { UitkFigure as UitkFigure2, UitkImage as UitkImage2 } from "uitk-react-images";
// src/components/destination-hero-media/image-aspect-ratio.ts
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType5 } from "uitk-react-images";
var ASPECT_RATIO_MAP = {
    FOUR_ONE: UitkFigureAspectRatioType5.R4_1,
    FOUR_THREE: UitkFigureAspectRatioType5.R4_3,
    ONE_ONE: UitkFigureAspectRatioType5.R1_1,
    SIXTEEN_NINE: UitkFigureAspectRatioType5.R16_9,
    THREE_FOUR: UitkFigureAspectRatioType5.R3_4,
    THREE_TWO: UitkFigureAspectRatioType5.R3_2,
    TWENTY_ONE_NINE: UitkFigureAspectRatioType5.R21_9
};
// src/components/destination-hero-media/__private/destination-hero-image/destination-hero-image.tsx
var fragment18 = gql45(_templateObject44());
var DestinationHeroImage = function(param) {
    var data = param.data, aspectRatio = param.aspectRatio, className = param.className, imageFit = param.imageFit, roundcorner = param.roundcorner, attribution = param.attribution;
    var url = data.url, description = data.description;
    return /* @__PURE__ */ React44.createElement(UitkFigure2, {
        className: className,
        ratio: aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : ASPECT_RATIO_MAP.TWENTY_ONE_NINE,
        imageFit: imageFit,
        roundcorner: roundcorner
    }, /* @__PURE__ */ React44.createElement(UitkImage2, {
        src: url,
        alt: description,
        additionalProps: {
            fetchpriority: "high"
        }
    }), attribution && /* @__PURE__ */ React44.createElement(MediaImageAttribution, {
        data: attribution
    }));
};
DestinationHeroImage.fragment = fragment18;
DestinationHeroImage.displayName = "DestinationHeroImage";
// src/components/destination-hero-media/destination-hero-media.tsx
var __Query3 = gql46(_templateObject45(), DestinationHeroImage.fragment, MediaImageAttribution.fragment);
var DestinationHeroMedia = function(props) {
    var _data_destinationHeroMedia_media, _data_destinationHeroMedia, _data_destinationHeroMedia_media1, _data_destinationHeroMedia1, _data_destinationHeroMedia_media2, _data_destinationHeroMedia2, _data_destinationHeroMedia3;
    var inputs = props.inputs, skipSsr = props.skipSsr, headingProps = props.headingProps;
    var context = useBexApi3().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery3 = useQuery3(__Query3, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery3.data, error = _useQuery3.error, loading = _useQuery3.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.destinationHeroMedia) || !(data === null || data === void 0 ? void 0 : (_data_destinationHeroMedia = data.destinationHeroMedia) === null || _data_destinationHeroMedia === void 0 ? void 0 : (_data_destinationHeroMedia_media = _data_destinationHeroMedia.media) === null || _data_destinationHeroMedia_media === void 0 ? void 0 : _data_destinationHeroMedia_media.media) || (data === null || data === void 0 ? void 0 : (_data_destinationHeroMedia1 = data.destinationHeroMedia) === null || _data_destinationHeroMedia1 === void 0 ? void 0 : (_data_destinationHeroMedia_media1 = _data_destinationHeroMedia1.media) === null || _data_destinationHeroMedia_media1 === void 0 ? void 0 : _data_destinationHeroMedia_media1.media.__typename) !== "Image") {
        return null;
    }
    var image = data === null || data === void 0 ? void 0 : (_data_destinationHeroMedia2 = data.destinationHeroMedia) === null || _data_destinationHeroMedia2 === void 0 ? void 0 : (_data_destinationHeroMedia_media2 = _data_destinationHeroMedia2.media) === null || _data_destinationHeroMedia_media2 === void 0 ? void 0 : _data_destinationHeroMedia_media2.media;
    var imageRatio = (image === null || image === void 0 ? void 0 : image.aspectRatio) ? ASPECT_RATIO_MAP[image.aspectRatio] : void 0;
    var attribution = data === null || data === void 0 ? void 0 : (_data_destinationHeroMedia3 = data.destinationHeroMedia) === null || _data_destinationHeroMedia3 === void 0 ? void 0 : _data_destinationHeroMedia3.media.attribution;
    var _data_destinationHeroMedia4 = data.destinationHeroMedia, title = _data_destinationHeroMedia4.title, subTitle = _data_destinationHeroMedia4.subTitle;
    var headerText = title ? /* @__PURE__ */ React45.createElement(UitkHeading8, _object_spread({}, headingProps), title.text) : void 0;
    var cardContentProps = {
        header: headerText,
        description: subTitle === null || subTitle === void 0 ? void 0 : subTitle.text
    };
    return /* @__PURE__ */ React45.createElement(Viewport3, null, /* @__PURE__ */ React45.createElement(ViewLarge2, null, /* @__PURE__ */ React45.createElement(UitkCard5, null, /* @__PURE__ */ React45.createElement(UitkLayoutPosition6, {
        type: "relative"
    }, /* @__PURE__ */ React45.createElement(DestinationHeroImage, {
        data: image,
        aspectRatio: imageRatio,
        attribution: attribution
    }), /* @__PURE__ */ React45.createElement(UitkScrim3, {
        type: UitkScrimType3.OVERLAY,
        "data-stid": "overlay"
    }, /* @__PURE__ */ React45.createElement(CardContent, _object_spread_props(_object_spread({}, cardContentProps), {
        verticallyCenter: true
    })))))), /* @__PURE__ */ React45.createElement(ViewMedium3, null, /* @__PURE__ */ React45.createElement(UitkCard5, null, /* @__PURE__ */ React45.createElement(UitkLayoutPosition6, {
        type: "relative"
    }, /* @__PURE__ */ React45.createElement(DestinationHeroImage, {
        data: image,
        aspectRatio: imageRatio,
        attribution: attribution
    }), /* @__PURE__ */ React45.createElement(UitkScrim3, {
        type: UitkScrimType3.OVERLAY,
        "data-stid": "overlay"
    }, /* @__PURE__ */ React45.createElement(CardContent, _object_spread_props(_object_spread({}, cardContentProps), {
        verticallyCenter: true,
        textFullWidth: true
    })))))), /* @__PURE__ */ React45.createElement(ViewSmall3, null, /* @__PURE__ */ React45.createElement(UitkCard5, null, /* @__PURE__ */ React45.createElement(UitkLayoutPosition6, {
        type: "relative"
    }, /* @__PURE__ */ React45.createElement(UitkSpacing22, {
        margin: {
            inline: "three"
        }
    }, /* @__PURE__ */ React45.createElement(React45.Fragment, null, /* @__PURE__ */ React45.createElement(DestinationHeroImage, {
        data: image,
        aspectRatio: imageRatio,
        attribution: attribution
    }), /* @__PURE__ */ React45.createElement(UitkScrim3, {
        type: UitkScrimType3.BOTTOM,
        "data-stid": "overlay"
    }, /* @__PURE__ */ React45.createElement(CardContent, _object_spread_props(_object_spread({}, cardContentProps), {
        verticallyCenter: true,
        textFullWidth: true
    })))))))));
};
DestinationHeroMedia.displayName = "sharedui-DestinationHeroMedia";
// src/components/destination-guide-neighborhood/destination-guide-neighborhood.tsx
import React46 from "react";
import { gql as gql47, useQuery as useQuery4 } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
import { UitkTab as UitkTab3, UitkTabs as UitkTabs3, UitkTabsType as UitkTabsType3 } from "uitk-react-tabs";
import { UitkHeading as UitkHeading9 } from "uitk-react-text";
var __Query4 = gql47(_templateObject46(), EGDSCarousel.fragment, DestinationRecommendationCard.fragment);
var DestinationGuideNeighborhood = function(props) {
    var _React46_useState = _sliced_to_array(React46.useState(0), 2), selectedTabIndex = _React46_useState[0], setSelectedTabIndexState = _React46_useState[1];
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi4().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery4 = useQuery4(__Query4, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery4.data, error = _useQuery4.error, loading = _useQuery4.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.destinationRecommendation)) {
        return null;
    }
    var destinationRecommendation = data.destinationRecommendation;
    var cards = destinationRecommendation.cards;
    var handleTabChange = function(tabIndex) {
        setSelectedTabIndexState(tabIndex);
    };
    return /* @__PURE__ */ React46.createElement(React46.Fragment, null, /* @__PURE__ */ React46.createElement(UitkSpacing23, {
        margin: {
            blockstart: "one"
        },
        padding: {
            blockstart: "four",
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React46.createElement(UitkHeading9, {
        size: 5
    }, data.destinationRecommendation.heading.title)), /* @__PURE__ */ React46.createElement(UitkSpacing23, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React46.createElement(UitkTabs3, {
        tabsType: UitkTabsType3.NATURAL,
        onTabSelect: handleTabChange,
        selectedTab: selectedTabIndex,
        scrollOffsetSelf: true
    }, cards.map(function(card, tabIndex) /* @__PURE__ */ {
        var _card_heading;
        var _card_heading_title;
        return React46.createElement(UitkTab3, {
            key: "tab".concat(tabIndex),
            name: (_card_heading_title = (_card_heading = card.heading) === null || _card_heading === void 0 ? void 0 : _card_heading.title) !== null && _card_heading_title !== void 0 ? _card_heading_title : "",
            targetURI: "tab".concat(tabIndex)
        }, /* @__PURE__ */ React46.createElement(UitkSpacing23, {
            padding: {
                inlinestart: "four"
            }
        }, /* @__PURE__ */ React46.createElement(DestinationRecommendationCard, {
            data: card,
            carousel: destinationRecommendation === null || destinationRecommendation === void 0 ? void 0 : destinationRecommendation.carousel
        })));
    }))));
};
DestinationGuideNeighborhood.displayName = "sharedui-DestinationGuideNeighborhood";
// src/components/destination-guide-expert-tips/destination-guide-expert-tips.tsx
import React48 from "react";
import { gql as gql49, useQuery as useQuery5 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { UitkSpacing as UitkSpacing25 } from "uitk-react-spacing";
import { UitkTab as UitkTab4, UitkTabs as UitkTabs4, UitkTabsType as UitkTabsType4 } from "uitk-react-tabs";
// src/components/destination-guide-expert-tips/__private/destination-tip-item.tsx
import React47 from "react";
import { gql as gql48 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing24 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading10, UitkText as UitkText17 } from "uitk-react-text";
var _Fragment9 = gql48(_templateObject47(), EGDSSpannableText.fragment, Icon.fragment);
var DestinationTipItem = function(param) {
    var data = param.data;
    var destinationTips = data.destinationTips, name = data.name;
    return /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(UitkHeading10, null, name), destinationTips === null || destinationTips === void 0 ? void 0 : destinationTips.map(function(item, index) {
        var _item_icon;
        return /* @__PURE__ */ React47.createElement(UitkSpacing24, {
            key: "item".concat(index),
            padding: "three"
        }, /* @__PURE__ */ React47.createElement(UitkLayoutFlex12, {
            direction: "row"
        }, /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React47.createElement(UitkLayoutFlex12, {
            direction: "column",
            justifyContent: "center"
        }, /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, (item === null || item === void 0 ? void 0 : (_item_icon = item.icon) === null || _item_icon === void 0 ? void 0 : _item_icon.id) && /* @__PURE__ */ React47.createElement(Icon, {
            data: item.icon
        })))), /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React47.createElement(UitkSpacing24, {
            margin: "three"
        }, (item === null || item === void 0 ? void 0 : item.description) && /* @__PURE__ */ React47.createElement(UitkText17, {
            size: 400,
            weight: "regular"
        }, item.description.text)))));
    }));
};
DestinationTipItem.fragment = _Fragment9;
DestinationTipItem.displayName = "DestinationTipItem";
// src/components/destination-guide-expert-tips/destination-guide-expert-tips.tsx
var __Query5 = gql49(_templateObject48(), DestinationTipItem.fragment);
var DestinationGuideExpertTips = function(props) {
    var _destinationExpertTips_tips;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi5().context;
    var _React48_useState = _sliced_to_array(React48.useState(0), 2), selectedTabIndex = _React48_useState[0], setSelectedTabIndexState = _React48_useState[1];
    var handleTabChange = function(tabIndex) {
        setSelectedTabIndexState(tabIndex);
    };
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery5 = useQuery5(__Query5, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery5.data, error = _useQuery5.error, loading = _useQuery5.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.destinationExpertTips)) {
        return null;
    }
    var destinationExpertTips = data.destinationExpertTips;
    return /* @__PURE__ */ React48.createElement(UitkTabs4, {
        onTabSelect: handleTabChange,
        selectedTab: selectedTabIndex,
        tabsType: UitkTabsType4.EQUAL_WIDTH,
        role: "tablist",
        withBorder: false
    }, (_destinationExpertTips_tips = destinationExpertTips.tips) === null || _destinationExpertTips_tips === void 0 ? void 0 : _destinationExpertTips_tips.map(function(tips, tabIndex) {
        var _tips_items;
        return /* @__PURE__ */ React48.createElement(UitkTab4, {
            name: tips.category,
            key: "destinationExpertTips".concat(tabIndex),
            targetURI: "destinationExpertTips".concat(tabIndex)
        }, /* @__PURE__ */ React48.createElement(UitkSpacing25, {
            margin: "six"
        }, /* @__PURE__ */ React48.createElement("div", null, (_tips_items = tips.items) === null || _tips_items === void 0 ? void 0 : _tips_items.map(function(tip, tipIndex) {
            return /* @__PURE__ */ React48.createElement(DestinationTipItem, {
                key: "DestinationTipItem".concat(tipIndex),
                data: tip
            });
        }))));
    }));
};
DestinationGuideExpertTips.displayName = "sharedui-DestinationGuideExpertTips";
// src/components/destination-guide-heading-tip/destination-guide-heading-tip.tsx
import React49 from "react";
import { gql as gql50, useQuery as useQuery6 } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
import { UitkCard as UitkCard6 } from "uitk-react-cards";
import { UitkIllustrations as UitkIllustrations2 } from "uitk-react-illustrations";
import { UitkLayoutFlex as UitkLayoutFlex13, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing26 } from "uitk-react-spacing";
import { UitkText as UitkText18 } from "uitk-react-text";
var __Query6 = gql50(_templateObject49(), Image.fragment, EGDSSpannableText.fragment);
var DestinationGuideHeadingTip = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi6().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery6 = useQuery6(__Query6, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery6.data, error = _useQuery6.error, loading = _useQuery6.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.destinationHeadingTip)) {
        return null;
    }
    var _data_destinationHeadingTip = data.destinationHeadingTip, lightImage = _data_destinationHeadingTip.lightImage, text = _data_destinationHeadingTip.text;
    return /* @__PURE__ */ React49.createElement(UitkCard6, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(UitkSpacing26, {
        padding: "two"
    }, /* @__PURE__ */ React49.createElement(UitkLayoutFlex13, {
        direction: "row"
    }, /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React49.createElement(UitkLayoutFlex13, {
        direction: "column",
        justifyContent: "center"
    }, /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem10, {
        maxWidth: "13x"
    }, lightImage && /* @__PURE__ */ React49.createElement(UitkIllustrations2, {
        url: lightImage.url,
        alt: lightImage.description
    })))), /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React49.createElement(UitkSpacing26, {
        margin: "three",
        padding: {
            inline: "two"
        }
    }, /* @__PURE__ */ React49.createElement(UitkText18, {
        size: 300,
        weight: "regular"
    }, text.text)))))));
};
DestinationGuideHeadingTip.displayName = "sharedui-DestinationGuideHeadingTip";
// src/components/destination-guide-things-to-do/destination-guide-things-to-do.tsx
import React52 from "react";
import { gql as gql53, useQuery as useQuery7 } from "@apollo/client";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
import { UitkTab as UitkTab5, UitkTabs as UitkTabs5, UitkTabsType as UitkTabsType5 } from "uitk-react-tabs";
// src/components/destination-recommendation-group/destination-recommendation-group.tsx
import React51 from "react";
import { gql as gql52 } from "@apollo/client";
import { UitkSpacing as UitkSpacing28 } from "uitk-react-spacing";
// src/components/destination-recommendation-heading/destination-recommendation-heading.tsx
import React50 from "react";
import { gql as gql51 } from "@apollo/client";
import { UitkSpacing as UitkSpacing27 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading11, UitkText as UitkText19 } from "uitk-react-text";
var _Fragment10 = gql51(_templateObject50());
var DestinationRecommendationHeading = function(param) {
    var data = param.data;
    var title = data.title, subTitle = data.subTitle, superTitle = data.superTitle;
    if (!data) {
        return null;
    }
    return /* @__PURE__ */ React50.createElement(React50.Fragment, null, superTitle && /* @__PURE__ */ React50.createElement(UitkSpacing27, {
        margin: {
            block: "one",
            inline: "six"
        }
    }, /* @__PURE__ */ React50.createElement(UitkText19, null, subTitle)), title && /* @__PURE__ */ React50.createElement(UitkSpacing27, {
        margin: {
            block: "one",
            inline: "six"
        }
    }, /* @__PURE__ */ React50.createElement(UitkHeading11, {
        size: 5
    }, title)), subTitle && /* @__PURE__ */ React50.createElement(UitkSpacing27, {
        margin: {
            block: "one",
            inline: "six"
        }
    }, /* @__PURE__ */ React50.createElement(UitkText19, null, subTitle)));
};
DestinationRecommendationHeading.fragment = _Fragment10;
DestinationRecommendationHeading.displayName = "DestinationRecommendationHeading";
// src/components/destination-recommendation-group/destination-recommendation-group.tsx
var _Fragment11 = gql52(_templateObject51(), DestinationRecommendationHeading.fragment, DestinationRecommendationCard.fragment, EGDSCarousel.fragment);
var DestinationRecommendationGroup = function(param) {
    var data = param.data;
    var cards = data.cards, carousel = data.carousel;
    return /* @__PURE__ */ React51.createElement(UitkSpacing28, {
        padding: {
            inlinestart: "six"
        }
    }, /* @__PURE__ */ React51.createElement(EGDSCarousel, {
        stretchToFill: true,
        customItemVisible: {
            sm: 2,
            md: 2,
            lg: 2,
            xl: 2
        },
        data: carousel,
        carouselContent: _to_consumable_array(cards),
        peek: true
    }));
};
DestinationRecommendationGroup.fragment = _Fragment11;
DestinationRecommendationGroup.displayName = "DestinationRecommendationGroup";
// src/components/destination-guide-things-to-do/destination-guide-things-to-do.tsx
var __Query7 = gql53(_templateObject52(), DestinationRecommendationHeading.fragment, DestinationRecommendationGroup.fragment);
var DestinationGuideThingsToDo = function(props) {
    var _React52_useState = _sliced_to_array(React52.useState(0), 2), selectedTabIndex = _React52_useState[0], setSelectedTabIndexState = _React52_useState[1];
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi7().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery7 = useQuery7(__Query7, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery7.data, error = _useQuery7.error, loading = _useQuery7.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.thingsToDo)) {
        return null;
    }
    var thingsToDo = data.thingsToDo;
    var groups = thingsToDo.groups, heading = thingsToDo.heading;
    var handleTabChange = function(tabIndex) {
        setSelectedTabIndexState(tabIndex);
    };
    return /* @__PURE__ */ React52.createElement(React52.Fragment, null, heading && /* @__PURE__ */ React52.createElement(DestinationRecommendationHeading, {
        data: heading
    }), /* @__PURE__ */ React52.createElement(UitkTabs5, {
        tabsType: UitkTabsType5.NATURAL,
        role: "tablist",
        onTabSelect: handleTabChange,
        selectedTab: selectedTabIndex,
        scrollOffsetSelf: true
    }, groups.map(function(group, tabIndex) {
        return /* @__PURE__ */ React52.createElement(UitkTab5, {
            key: "tab".concat(tabIndex),
            name: group.heading.title,
            targetURI: "tab".concat(tabIndex)
        }, /* @__PURE__ */ React52.createElement(DestinationRecommendationGroup, {
            data: group
        }));
    })));
};
DestinationGuideThingsToDo.displayName = "sharedui-DestinationGuideThingsToDo";
// src/components/destination-guide-best-time-to-go/destination-guide-best-time-to-go.tsx
import React53 from "react";
import { gql as gql54, useQuery as useQuery8 } from "@apollo/client";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard7 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing29 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading12 } from "uitk-react-text";
var __Query8 = gql54(_templateObject53(), EGDSSpannableText.fragment, DestinationMonthlyHistoricalForecast.fragment);
var DestinationGuideBestTimeToGo = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, customHeight = props.customHeight, isScrollable = props.isScrollable;
    var context = useBexApi8().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery8 = useQuery8(__Query8, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery8.data, error = _useQuery8.error, loading = _useQuery8.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.bestTimeToGo)) {
        return null;
    }
    var bestTimeToGo = data.bestTimeToGo;
    var title = bestTimeToGo.title, subtitle = bestTimeToGo.subtitle, monthlyHistoricalForecast = bestTimeToGo.monthlyHistoricalForecast;
    return /* @__PURE__ */ React53.createElement(IntersectionTracker3, {
        referrerId: bestTimeToGo.impression.referrerId,
        linkName: bestTimeToGo.impression.linkName,
        trackOnce: true
    }, /* @__PURE__ */ React53.createElement(UitkCard7, {
        border: true,
        padded: true
    }, /* @__PURE__ */ React53.createElement(UitkSpacing29, {
        padding: {
            small: {
                inlinestart: "two"
            },
            large: {
                inline: "three"
            },
            medium: {
                inline: "three"
            }
        }
    }, /* @__PURE__ */ React53.createElement(UitkHeading12, {
        tag: "h1",
        size: 4
    }, title)), subtitle.text && subtitle.text !== "" && /* @__PURE__ */ React53.createElement(UitkSpacing29, {
        padding: {
            large: {
                inline: "three",
                blockstart: "three"
            },
            small: {
                inlinestart: "two",
                blockstart: "three"
            },
            medium: {
                inline: "three",
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(EGDSSpannableText, {
        data: subtitle
    }))), /* @__PURE__ */ React53.createElement(UitkSpacing29, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(DestinationMonthlyHistoricalForecast, {
        data: monthlyHistoricalForecast,
        customHeight: customHeight,
        isScrollable: isScrollable
    })))));
};
DestinationGuideBestTimeToGo.displayName = "sharedui-DestinationGuideBestTimeToGo";
// src/components/destination-price-insights/destination-price-insights.tsx
import React55 from "react";
import { gql as gql57, useQuery as useQuery9 } from "@apollo/client";
import { RangeIndicator, RangeIndicatorSegmentStyle, RangeIndicatorSegmentTheme } from "@egds/react-acquisition-marketing-growth-landing";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard9 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex15, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing31 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading13, UitkText as UitkText20 } from "uitk-react-text";
// src/utils/fragments/destination-insights-price-range/destination-insights-price-range.tsx
import { gql as gql55 } from "@apollo/client";
var DestinationInsightsPriceRangeFragment = gql55(_templateObject54(), DestinationInsightsPriceFragment);
// src/components/price-insights-expando-card/price-insights-expando-card.tsx
import React54 from "react";
import { gql as gql56 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize2, UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { UitkCard as UitkCard8 } from "uitk-react-cards";
import { UitkIcon as UitkIcon5 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex14, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing30 } from "uitk-react-spacing";
var priceInsightsExpandoCardFragment = gql56(_templateObject55());
var PriceInsightsExpandoCard = function(param) {
    var children = param.children, data = param.data, expandoTitleMoreInfoTrigger = param.expandoTitleMoreInfoTrigger, className = param.className, border = param.border, hasButtonLabel = param.hasButtonLabel, padded = param.padded, expandoIcon = param.expandoIcon, expandoButtonMargin = param.expandoButtonMargin;
    var expandedLabel = data.expandedLabel, collapsedLabel = data.collapsedLabel, expanded = data.expanded, collapseAnalytics = data.collapseAnalytics, expandAnalytics = data.expandAnalytics, expandedAccessibilityText = data.expandedAccessibilityText, collapsedAccessibilityText = data.collapsedAccessibilityText;
    var _React54_useState = _sliced_to_array(React54.useState(expanded), 2), isVisible = _React54_useState[0], setIsVisible = _React54_useState[1];
    var _React54_useState1 = _sliced_to_array(React54.useState(expanded ? expandedLabel : collapsedLabel), 2), label = _React54_useState1[0], setLabel = _React54_useState1[1];
    var track = useClickTracker11();
    var padding = {
        inline: "three"
    };
    var onToggle = React54.useCallback(function() {
        if (collapseAnalytics && expandAnalytics) {
            var referrerId = isVisible ? collapseAnalytics.referrerId : expandAnalytics.referrerId;
            var linkName = isVisible ? collapseAnalytics.linkName : expandAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (isVisible) {
            setLabel(collapsedLabel);
        } else {
            setLabel(expandedLabel);
        }
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    return /* @__PURE__ */ React54.createElement(UitkCard8, _object_spread({
        border: border,
        padded: padded,
        className: className
    }, !hasButtonLabel ? {
        onClick: onToggle
    } : {}), /* @__PURE__ */ React54.createElement(UitkLayoutFlex14, {
        direction: "row",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React54.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React54.createElement(UitkSpacing30, _object_spread({}, padded ? {
        padding: padding
    } : {}), /* @__PURE__ */ React54.createElement("div", null, expandoTitleMoreInfoTrigger, /* @__PURE__ */ React54.createElement(UitkSpacing30, _object_spread({}, expandoButtonMargin ? {
        margin: expandoButtonMargin
    } : {}), /* @__PURE__ */ React54.createElement(UitkTertiaryButton3, {
        size: UitkButtonSize2.MEDIUM,
        onClick: onToggle
    }, /* @__PURE__ */ React54.createElement(UitkLayoutFlex14, {
        space: "one"
    }, expandoIcon && /* @__PURE__ */ React54.createElement(Icon, {
        data: expandoIcon
    }), label), expandedAccessibilityText && !isVisible && /* @__PURE__ */ React54.createElement("span", {
        className: "is-visually-hidden"
    }, expandedAccessibilityText), collapsedAccessibilityText && isVisible && /* @__PURE__ */ React54.createElement("span", {
        className: "is-visually-hidden"
    }, collapsedAccessibilityText)))))), /* @__PURE__ */ React54.createElement(UitkLayoutFlexItem11, {
        alignSelf: "center"
    }, /* @__PURE__ */ React54.createElement(UitkSpacing30, {
        padding: padding
    }, /* @__PURE__ */ React54.createElement("div", null, /* @__PURE__ */ React54.createElement(UitkTertiaryButton3, {
        onClick: onToggle
    }, /* @__PURE__ */ React54.createElement(UitkIcon5, {
        name: isVisible ? "arrow_upward_iOS" : "arrow_downward_iOS",
        id: isVisible ? "arrow_upward_iOS" : "arrow_downward_iOS",
        description: isVisible ? expandedLabel : collapsedLabel,
        theme: "default",
        title: isVisible ? expandedLabel : collapsedLabel
    })))))), /* @__PURE__ */ React54.createElement(UitkSpacing30, null, /* @__PURE__ */ React54.createElement("div", null, isVisible && children)));
};
PriceInsightsExpandoCard.fragment = priceInsightsExpandoCardFragment;
PriceInsightsExpandoCard.displayName = "PriceInsightsExpandoCard";
// src/components/destination-price-insights/destination-price-insights.tsx
var __Query9 = gql57(_templateObject56(), EGDSSpannableText.fragment, Icon.fragment, PriceInsightsExpandoCard.fragment, DestinationInsightsMonthlyDetails.fragment, ClientSideAnalyticsFragment, DestinationInsightsPriceRangeFragment, DestinationInsightsPriceFragment);
var DestinationPriceInsights = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi9().context;
    var fullCollapsed = props.fullCollapsed, customId = props.customId;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery9 = useQuery9(__Query9, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery9.data, error = _useQuery9.error, loading = _useQuery9.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.destinationPriceInsights)) {
        return null;
    }
    var destinationPriceInsights = data.destinationPriceInsights;
    var expando = destinationPriceInsights.expando, superTitle = destinationPriceInsights.superTitle, currentMonthAverage = destinationPriceInsights.currentMonthAverage, typicalRange = destinationPriceInsights.typicalRange, title = destinationPriceInsights.title, subtitle = destinationPriceInsights.subtitle, expandoIcon = destinationPriceInsights.expandoIcon, impression = destinationPriceInsights.impression;
    var expandoTitleMoreInfoTriggerComponent = superTitle && /* @__PURE__ */ React55.createElement(EGDSSpannableText, {
        data: superTitle,
        padding: {
            blockend: "one",
            inlineend: "two"
        }
    });
    var expandoTitleMobileMoreInfoTriggerComponent = title && /* @__PURE__ */ React55.createElement(UitkSpacing31, {
        padding: {
            inlinestart: "three",
            blockstart: "three"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(EGDSSpannableText, {
        data: title,
        padding: {
            blockend: "one",
            inlineend: "two"
        }
    })));
    var rangeIndicator = /* @__PURE__ */ React55.createElement(UitkSpacing31, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React55.createElement(UitkLayoutFlex15, {
        direction: "column",
        space: "two"
    }, /* @__PURE__ */ React55.createElement(UitkLayoutFlexItem12, null, !fullCollapsed && /* @__PURE__ */ React55.createElement(UitkHeading13, null, /* @__PURE__ */ React55.createElement(EGDSSpannableText, {
        data: title
    }))), /* @__PURE__ */ React55.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React55.createElement(UitkText20, null, /* @__PURE__ */ React55.createElement(EGDSSpannableText, {
        data: subtitle
    }))), /* @__PURE__ */ React55.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React55.createElement(UitkSpacing31, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(RangeIndicator, {
        segments: [
            {
                theme: RangeIndicatorSegmentTheme.VERY_POSITIVE
            },
            {
                pins: [
                    {
                        badge: {
                            text: currentMonthAverage === null || currentMonthAverage === void 0 ? void 0 : currentMonthAverage.priceAsText
                        },
                        percentage: 50,
                        value: currentMonthAverage === null || currentMonthAverage === void 0 ? void 0 : currentMonthAverage.priceAsNumber,
                        min: typicalRange === null || typicalRange === void 0 ? void 0 : typicalRange.lowerBound.priceAsNumber,
                        max: typicalRange === null || typicalRange === void 0 ? void 0 : typicalRange.higherBound.priceAsNumber
                    }
                ],
                style: RangeIndicatorSegmentStyle.EMPHASIS,
                theme: RangeIndicatorSegmentTheme.POSITIVE
            },
            {
                theme: RangeIndicatorSegmentTheme.NEUTRAL
            }
        ],
        milestones: [
            {
                text: typicalRange === null || typicalRange === void 0 ? void 0 : typicalRange.lowerBound.priceAsText,
                size: 200,
                weight: "medium"
            },
            {
                text: typicalRange === null || typicalRange === void 0 ? void 0 : typicalRange.higherBound.priceAsText,
                size: 200,
                weight: "medium"
            }
        ]
    }))))));
    return /* @__PURE__ */ React55.createElement(IntersectionTracker4, {
        referrerId: impression.referrerId,
        linkName: impression.linkName,
        trackOnce: true
    }, /* @__PURE__ */ React55.createElement(Viewport4, null, /* @__PURE__ */ React55.createElement(ViewSmall4, null, /* @__PURE__ */ React55.createElement(UitkCard9, {
        border: true
    }, !fullCollapsed && /* @__PURE__ */ React55.createElement(UitkSpacing31, {
        padding: "three"
    }, rangeIndicator), expando && /* @__PURE__ */ React55.createElement(PriceInsightsExpandoCard, _object_spread(_object_spread_props(_object_spread({
        expandoButtonMargin: {
            inlinestart: "one",
            block: "three"
        }
    }, expandoIcon ? {
        expandoIcon: expandoIcon
    } : {}), {
        hasButtonLabel: true,
        data: destinationPriceInsights.expando
    }), fullCollapsed ? {
        expandoTitleMoreInfoTrigger: expandoTitleMobileMoreInfoTriggerComponent
    } : {}), /* @__PURE__ */ React55.createElement("div", null, fullCollapsed && /* @__PURE__ */ React55.createElement(UitkSpacing31, {
        padding: "three"
    }, rangeIndicator), /* @__PURE__ */ React55.createElement(DestinationInsightsMonthlyDetails, {
        data: destinationPriceInsights.monthlyDetails,
        customId: customId
    }))))), /* @__PURE__ */ React55.createElement(ViewMedium4, null, /* @__PURE__ */ React55.createElement(React55.Fragment, null, expando && /* @__PURE__ */ React55.createElement(PriceInsightsExpandoCard, {
        hasButtonLabel: true,
        expandoTitleMoreInfoTrigger: expandoTitleMoreInfoTriggerComponent,
        data: destinationPriceInsights.expando,
        border: true,
        padded: true,
        expandoButtonMargin: {
            inline: "one"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(DestinationInsightsMonthlyDetails, {
        rangeIndicator: rangeIndicator,
        data: destinationPriceInsights.monthlyDetails,
        customId: customId
    })))))));
};
DestinationPriceInsights.displayName = "sharedui-DestinationPriceInsights";
// src/components/similar-destination/similar-destination.tsx
import React59 from "react";
import { gql as gql61, useQuery as useQuery10 } from "@apollo/client";
import { useBexApi as useBexApi10 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing as UitkSpacing33 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading14 } from "uitk-react-text";
// src/components/similar-destination/utils/similar-destination-views.ts
var SimilarDestinationViews = {
    TAB: "tab",
    SINGLE_DESTINATION: "single"
};
// src/components/similar-destination/__private/similar-destination-tabs.tsx
import React58, { useCallback as useCallback2 } from "react";
import { gql as gql60 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-text-icon-list/egds-text-icon-list.tsx
import React57 from "react";
import { gql as gql59 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex17 } from "uitk-react-layout-flex";
// ../internal/src/components/egds-text-icon-list/egds-text-icon-list-item.tsx
import React56 from "react";
import { gql as gql58 } from "@apollo/client";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex16, UitkLayoutFlexItem as UitkLayoutFlexItem13 } from "uitk-react-layout-flex";
import { UitkText as UitkText21 } from "uitk-react-text";
var __fragment5 = gql58(_templateObject57());
var EGDSTextIconListItem = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React56.createElement(UitkLayoutFlexItem13, {
        alignSelf: "start"
    }, /* @__PURE__ */ React56.createElement(UitkLayoutFlex16, {
        space: "two"
    }, /* @__PURE__ */ React56.createElement(UitkIcon6, {
        theme: "default",
        name: data.icon.id,
        size: UitkIconSize3.EXTRA_SMALL
    }), /* @__PURE__ */ React56.createElement(UitkText21, {
        theme: "standard",
        size: 200,
        overflow: "truncate-2-lines"
    }, data.text)));
};
EGDSTextIconListItem.fragment = __fragment5;
EGDSTextIconListItem.displayName = "EGDSTextIconListItem";
// ../internal/src/components/egds-text-icon-list/egds-text-icon-list.tsx
var __fragment6 = gql59(_templateObject58(), EGDSTextIconListItem.fragment);
var EGDSTextIconList = function(param) {
    var data = param.data, _param_wrap = param.wrap, wrap = _param_wrap === void 0 ? "nowrap" : _param_wrap, _param_space = param.space, space = _param_space === void 0 ? "half" : _param_space;
    return /* @__PURE__ */ React57.createElement(UitkLayoutFlex17, {
        space: space,
        wrap: wrap
    }, data.listItems.map(function(item, index) {
        return /* @__PURE__ */ React57.createElement(EGDSTextIconListItem, {
            data: item,
            key: index
        });
    }));
};
EGDSTextIconList.fragment = __fragment6;
EGDSTextIconList.displayName = "EGDSTextIconList";
// src/components/similar-destination/__private/similar-destination-tabs.tsx
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2 } from "@shared-ui/viewport-context";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType7 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex18 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid10, UitkLayoutGridItem as UitkLayoutGridItem10 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing32 } from "uitk-react-spacing";
import { UitkTab as UitkTab6, UitkTabs as UitkTabs6, UitkTabsType as UitkTabsType6 } from "uitk-react-tabs";
import { UitkText as UitkText22 } from "uitk-react-text";
var fragment19 = gql60(_templateObject59(), EGDSParagraph.fragment, EGDSCarousel.fragment, EGDSButton.fragment, EGDSTextIconList.fragment, DestinationRecommendationCardMedia.fragment);
var SimilarDestinationTabs = function(props) {
    var similarDestinationsView = props.similarDestinationsView, data = props.data;
    var carousel = data.carousel, cards = data.cards;
    var clickTracker = useClickTracker13();
    var _React58_useState = _sliced_to_array(React58.useState(0), 2), selectedTabIndex = _React58_useState[0], setSelectedTabIndex = _React58_useState[1];
    var viewSize = useMediaQueries2({
        viewSizes: defaultViewSizes2
    });
    var isLargeViewport = viewSize >= defaultViewSizes2.LARGE;
    var isSmallViewport = viewSize === defaultViewSizes2.SMALL;
    var enableTabView = cards.length >= 2 || similarDestinationsView === SimilarDestinationViews.TAB;
    var handleTabChange = useCallback2(function(tabIndex) {
        var _ref = cards[tabIndex].analytics || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
        if (selectedTabIndex !== tabIndex && referrerId) {
            clickTracker(referrerId, linkName !== null && linkName !== void 0 ? linkName : "");
        }
        setSelectedTabIndex(tabIndex);
    }, [
        setSelectedTabIndex,
        selectedTabIndex
    ]);
    React58.useEffect(function() {
        var _ref = cards[0].analytics || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
        if (referrerId) {
            clickTracker(referrerId, linkName !== null && linkName !== void 0 ? linkName : "");
        }
    }, []);
    var singleView = /* @__PURE__ */ React58.createElement(UitkSpacing32, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React58.createElement(UitkLayoutGrid10, {
        columns: {
            medium: [
                "1fr",
                "1fr"
            ],
            large: [
                "1fr",
                "3fr"
            ]
        },
        space: "six",
        areas: {
            small: [
                "carousel",
                "description"
            ],
            medium: [
                "description carousel"
            ]
        }
    }, /* @__PURE__ */ React58.createElement(UitkLayoutGridItem10, {
        area: "description"
    }, /* @__PURE__ */ React58.createElement("div", null, cards[0].details.map(function(detail, index) {
        var _detail_content, _detail_content1, _detail_heading;
        return /* @__PURE__ */ React58.createElement(React58.Fragment, {
            key: index
        }, /* @__PURE__ */ React58.createElement(UitkSpacing32, {
            padding: {
                small: {
                    inline: "two"
                },
                large: {
                    inline: "unset"
                }
            },
            margin: {
                small: {
                    blockstart: "two"
                },
                large: {
                    blockstart: "unset"
                }
            }
        }, /* @__PURE__ */ React58.createElement("div", null, ((_detail_content = detail.content) === null || _detail_content === void 0 ? void 0 : _detail_content.__typename) === "EGDSParagraph" && /* @__PURE__ */ React58.createElement(EGDSParagraph, {
            data: detail.content
        }), ((_detail_content1 = detail.content) === null || _detail_content1 === void 0 ? void 0 : _detail_content1.__typename) === "EGDSTextIconList" && /* @__PURE__ */ React58.createElement(React58.Fragment, null, /* @__PURE__ */ React58.createElement(UitkSpacing32, {
            margin: {
                blockstart: "four"
            }
        }, /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement(UitkText22, {
            size: 200,
            weight: "bold"
        }, (_detail_heading = detail.heading) === null || _detail_heading === void 0 ? void 0 : _detail_heading.title))), /* @__PURE__ */ React58.createElement(UitkSpacing32, {
            margin: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement(EGDSTextIconList, {
            data: detail.content,
            wrap: "wrap",
            space: "three"
        })))))), detail.button && /* @__PURE__ */ React58.createElement(UitkLayoutFlex18, {
            justifyContent: isSmallViewport ? "center" : "start"
        }, /* @__PURE__ */ React58.createElement(UitkSpacing32, {
            margin: {
                blockstart: "four"
            }
        }, /* @__PURE__ */ React58.createElement(EGDSButton, {
            data: detail.button
        }))));
    }))), /* @__PURE__ */ React58.createElement(UitkLayoutGridItem10, {
        area: "carousel"
    }, /* @__PURE__ */ React58.createElement(DestinationRecommendationCardMedia, {
        data: cards[0].media,
        carousel: carousel,
        ratio: isLargeViewport ? UitkFigureAspectRatioType7.R21_9 : UitkFigureAspectRatioType7.R4_3
    }))));
    var tabView = /* @__PURE__ */ React58.createElement(UitkTabs6, {
        tabsType: UitkTabsType6.NATURAL,
        role: "tablist",
        onTabSelect: handleTabChange,
        selectedTab: selectedTabIndex,
        scrollOffsetSelf: true
    }, cards.map(function(card, tabIndex) /* @__PURE__ */ {
        var _card_heading;
        var _card_heading_title;
        return React58.createElement(UitkTab6, {
            key: "tab".concat(tabIndex),
            name: (_card_heading_title = (_card_heading = card.heading) === null || _card_heading === void 0 ? void 0 : _card_heading.title) !== null && _card_heading_title !== void 0 ? _card_heading_title : "",
            targetURI: "tab".concat(tabIndex)
        }, /* @__PURE__ */ React58.createElement(UitkSpacing32, {
            margin: {
                blockstart: "one"
            }
        }, /* @__PURE__ */ React58.createElement(UitkLayoutGrid10, {
            columns: {
                medium: [
                    "1fr",
                    "1fr"
                ],
                large: [
                    "1fr",
                    "3fr"
                ]
            },
            space: "six",
            areas: {
                small: [
                    "carousel",
                    "description"
                ],
                medium: [
                    "description carousel"
                ]
            }
        }, /* @__PURE__ */ React58.createElement(UitkLayoutGridItem10, {
            area: "description"
        }, /* @__PURE__ */ React58.createElement("div", null, card.details.map(function(detail, index) {
            var _detail_content, _detail_content1, _detail_heading;
            return /* @__PURE__ */ React58.createElement(React58.Fragment, {
                key: index
            }, /* @__PURE__ */ React58.createElement(UitkSpacing32, {
                padding: {
                    small: {
                        inline: "two"
                    },
                    large: {
                        inline: "unset"
                    }
                },
                margin: {
                    small: {
                        blockstart: "two"
                    },
                    large: {
                        blockstart: "unset"
                    }
                }
            }, /* @__PURE__ */ React58.createElement("div", null, ((_detail_content = detail.content) === null || _detail_content === void 0 ? void 0 : _detail_content.__typename) === "EGDSParagraph" && /* @__PURE__ */ React58.createElement(EGDSParagraph, {
                data: detail.content
            }), ((_detail_content1 = detail.content) === null || _detail_content1 === void 0 ? void 0 : _detail_content1.__typename) === "EGDSTextIconList" && /* @__PURE__ */ React58.createElement(React58.Fragment, null, /* @__PURE__ */ React58.createElement(UitkSpacing32, {
                margin: {
                    blockstart: "four"
                }
            }, /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement(UitkText22, {
                size: 200,
                weight: "bold"
            }, (_detail_heading = detail.heading) === null || _detail_heading === void 0 ? void 0 : _detail_heading.title))), /* @__PURE__ */ React58.createElement(UitkSpacing32, {
                margin: {
                    blockstart: "two"
                }
            }, /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement(EGDSTextIconList, {
                data: detail.content,
                wrap: "wrap",
                space: "three"
            })))))), detail.button && /* @__PURE__ */ React58.createElement(UitkLayoutFlex18, {
                justifyContent: isSmallViewport ? "center" : "start"
            }, /* @__PURE__ */ React58.createElement(UitkSpacing32, {
                margin: {
                    blockstart: "four"
                }
            }, /* @__PURE__ */ React58.createElement(EGDSButton, {
                data: detail.button
            }))));
        }))), /* @__PURE__ */ React58.createElement(UitkLayoutGridItem10, {
            area: "carousel"
        }, /* @__PURE__ */ React58.createElement(DestinationRecommendationCardMedia, {
            data: card.media,
            carousel: carousel,
            ratio: isLargeViewport ? UitkFigureAspectRatioType7.R21_9 : UitkFigureAspectRatioType7.R4_3
        })))));
    }));
    return /* @__PURE__ */ React58.createElement(React58.Fragment, null, enableTabView ? tabView : singleView);
};
SimilarDestinationTabs.fragment = fragment19;
SimilarDestinationTabs.displayName = "SimilarDestinationTabs";
// src/components/similar-destination/similar-destination.tsx
var __Query10 = gql61(_templateObject60(), SimilarDestinationTabs.fragment);
var SimilarDestination = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_similarDestinationsView = props.similarDestinationsView, similarDestinationsView = _props_similarDestinationsView === void 0 ? SimilarDestinationViews.TAB : _props_similarDestinationsView, className = props.className;
    var context = useBexApi10().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery10 = useQuery10(__Query10, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery10.data, error = _useQuery10.error, loading = _useQuery10.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.similarDestinations)) {
        return null;
    }
    var similarDestinations = data.similarDestinations;
    var heading = similarDestinations.heading, impression = similarDestinations.impression;
    var body = /* @__PURE__ */ React59.createElement(React59.Fragment, null, /* @__PURE__ */ React59.createElement(UitkHeading14, {
        tag: "h4",
        size: 4,
        align: "left"
    }, heading.title), /* @__PURE__ */ React59.createElement(UitkSpacing33, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React59.createElement("div", null, /* @__PURE__ */ React59.createElement(SimilarDestinationTabs, {
        data: similarDestinations,
        similarDestinationsView: similarDestinationsView
    }))));
    var _impression_linkName;
    return /* @__PURE__ */ React59.createElement("div", {
        className: className
    }, (impression === null || impression === void 0 ? void 0 : impression.referrerId) && (impression === null || impression === void 0 ? void 0 : impression.referrerId) !== "" ? /* @__PURE__ */ React59.createElement(IntersectionTracker5, {
        trackOnce: true,
        referrerId: impression.referrerId,
        linkName: (_impression_linkName = impression.linkName) !== null && _impression_linkName !== void 0 ? _impression_linkName : ""
    }, body) : body);
};
SimilarDestination.displayName = "sharedui-SimilarDestination";
export { DestinationBestTimeToGoInformation, DestinationGuideBestTimeToGo, DestinationGuideExpertTips, DestinationGuideHeading, DestinationGuideHeadingTip, DestinationGuideNeighborhood, DestinationGuideThingsToDo, DestinationHeroMedia, DestinationPriceInsights, DestinationRecommendationPlaceType, DestinationRecommendationStrategy, SimilarDestination, SimilarDestinationViews }; /* istanbul ignore next -- @preserve */ 
//# sourceMappingURL=index.js.map